var _defs, _path, _g, _path2, _path3, _path4, _g2, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpensourceHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "opensource-hero_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 540"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".opensource-hero_svg__cls-4{fill:#52c7ea}.opensource-hero_svg__cls-3{fill:#152935}.opensource-hero_svg__cls-5{fill:#0a1a2b}.opensource-hero_svg__cls-12{opacity:.3;isolation:isolate}.opensource-hero_svg__cls-7{fill:#162535}.opensource-hero_svg__cls-12,.opensource-hero_svg__cls-8{fill:#161b20}.opensource-hero_svg__cls-9{fill:#192b3d}.opensource-hero_svg__cls-10{fill:#4bc7ec}.opensource-hero_svg__cls-11{fill:#2f393f}.opensource-hero_svg__cls-13{fill:#262e33}.opensource-hero_svg__cls-14{fill:#21282d}.opensource-hero_svg__cls-15{fill:#1b2126}.opensource-hero_svg__cls-16{fill:#ec432d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    fill: "#52c7ea",
    d: "M455.61 332.04l-98.35 58.05-90.54-52.24-88.98 51.34-98.35-58.06 88.67-51.15-91.39-52.74 98.35-58.05 90.54 52.23 88.98-51.34 98.34 58.06-88.67 51.16 91.4 52.74z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__core"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__grafika"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path",
    className: "opensource-hero_svg__cls-3",
    d: "M266.14 347.6l-99.8-58.01 99.8-58 99.8 58.01-99.8 58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M266.14 347.87l-.12-.07-100.15-58.21.35-.21 99.92-58.06.12.07 100.15 58.21zm-99.33-58.28l99.33 57.73 99.33-57.72-99.33-57.74z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-2",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M256.13 215.43a3.72 3.72 0 01-1.83-.57l-12.87-7.5.19-.33 12.81 7.49a2.56 2.56 0 002.57.28 2.59 2.59 0 001.05-2.39v-3.12a2.59 2.59 0 011.23-2.74 2.55 2.55 0 013 .27l2.68 1.56-.19.34-2.69-1.57a2.16 2.16 0 00-2.63-.35 2.21 2.21 0 00-1 2.46v3.13a3 3 0 01-1.22 2.73 2.33 2.33 0 01-1.1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M256.13 215.79a4 4 0 01-2-.62l-12.86-7.49a.41.41 0 01-.17-.22.38.38 0 010-.28l.19-.34a.38.38 0 01.51-.13l12.81 7.5a1.84 1.84 0 003.07-1.76v-3.16a2.93 2.93 0 014.8-2.75l2.62 1.52a.36.36 0 01.14.49l-.18.34a.41.41 0 01-.22.19.42.42 0 01-.29 0l-2.69-1.57a.21.21 0 01-.08-.06 1.83 1.83 0 00-2.19-.3 1.86 1.86 0 00-.86 2.06v3.22a3.32 3.32 0 01-1.38 3 2.62 2.62 0 01-1.22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-3",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M251 218.78a3.55 3.55 0 01-1.82-.57l-12.81-7.49.18-.33 12.87 7.49a2.16 2.16 0 002.56.28 2.22 2.22 0 001-2.39v-3.12a2.62 2.62 0 011.22-2.75 2.55 2.55 0 013 .28l2.68 1.57-.19.33-2.69-1.57a2.18 2.18 0 00-2.63-.36 2.24 2.24 0 00-1 2.47v3.13a2.93 2.93 0 01-1.22 2.72 2.2 2.2 0 01-1.12.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M251 219.15a3.9 3.9 0 01-2-.63L236.21 211a.36.36 0 01-.14-.5l.18-.33a.39.39 0 01.22-.18.42.42 0 01.29 0l12.86 7.49a1.82 1.82 0 003-1.71v-3.2a2.92 2.92 0 014.78-2.75l2.63 1.53a.37.37 0 01.13.5l-.19.33a.33.33 0 01-.23.17.39.39 0 01-.28 0l-2.68-1.57-.07-.06a1.81 1.81 0 00-2.18-.3 1.86 1.86 0 00-.86 2.06v3.22a3.3 3.3 0 01-1.37 3 2.64 2.64 0 01-1.33.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-4",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M246 221.3a3.62 3.62 0 01-1.83-.57l-12.84-7.48.2-.34 12.83 7.49a2.16 2.16 0 002.56.27 2.19 2.19 0 001-2.38v-3.13a2.6 2.6 0 011.23-2.74 2.52 2.52 0 013 .28l2.69 1.56-.2.34L252 213a2.56 2.56 0 00-2.57-.27 2.59 2.59 0 00-1 2.38v3.12a3 3 0 01-1.22 2.73 2.14 2.14 0 01-1.21.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M246 221.67a4 4 0 01-2-.63l-12.82-7.47a.38.38 0 01-.14-.5l.2-.35a.41.41 0 01.22-.17.37.37 0 01.29 0l12.83 7.49a1.83 1.83 0 002.19.28 1.85 1.85 0 00.86-2v-3.21a2.92 2.92 0 014.79-2.74L255 214a.36.36 0 01.13.5l-.19.33a.33.33 0 01-.23.17.35.35 0 01-.28 0l-2.67-1.56a1.83 1.83 0 00-3.06 1.75v3.16a3.33 3.33 0 01-1.37 3 2.61 2.61 0 01-1.33.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-5",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M241 224.66a3.78 3.78 0 01-1.84-.57l-12.83-7.49.19-.34 12.84 7.48a2.52 2.52 0 002.56.29 2.62 2.62 0 001-2.38v-3.14a2.6 2.6 0 011.23-2.73 2.55 2.55 0 013 .27l2.67 1.56-.2.34-2.68-1.55a2.19 2.19 0 00-2.61-.33 2.22 2.22 0 00-1.05 2.44v3.14a3 3 0 01-1.22 2.71 2.24 2.24 0 01-1.06.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M241 225a4.14 4.14 0 01-2-.63l-12.83-7.48a.37.37 0 01-.13-.5l.19-.35a.4.4 0 01.23-.17.4.4 0 01.28 0l12.83 7.49a2.18 2.18 0 002.23.26 2.25 2.25 0 00.82-2v-3.18a2.94 2.94 0 014.81-2.74l2.62 1.52a.38.38 0 01.13.51l-.2.33a.36.36 0 01-.5.13l-2.68-1.54a1.85 1.85 0 00-3.13 1.71v3.22a3.3 3.3 0 01-1.37 3 2.62 2.62 0 01-1.3.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-6",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M235.93 227.17a3.68 3.68 0 01-1.84-.57l-12.81-7.52.2-.33 12.83 7.51a2.49 2.49 0 002.56.28 2.61 2.61 0 001-2.39v-3.1a2.61 2.61 0 011.23-2.75 2.53 2.53 0 013 .27l2.67 1.58-.19.33-2.67-1.56a2.51 2.51 0 00-2.57-.28 2.63 2.63 0 00-1 2.41v3.1a3 3 0 01-1.22 2.72 2.09 2.09 0 01-1.22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M236.06 227.54h-.15a4.17 4.17 0 01-2-.63l-12.81-7.51a.37.37 0 01-.14-.5l.2-.34a.41.41 0 01.22-.17.38.38 0 01.28 0l12.83 7.51a2.2 2.2 0 002.23.27 2.3 2.3 0 00.84-2v-3.14A2.94 2.94 0 01239 218a2.9 2.9 0 013.39.32l2.62 1.53a.37.37 0 01.13.5l-.19.34a.4.4 0 01-.23.17.4.4 0 01-.28 0l-2.67-1.56a2.16 2.16 0 00-2.23-.27 2.28 2.28 0 00-.76 2v3.15a3.33 3.33 0 01-1.37 3 2.53 2.53 0 01-1.35.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-7",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M230.89 230.53a3.77 3.77 0 01-1.84-.56l-12.8-7.47.19-.33 12.81 7.47a2.16 2.16 0 002.6.32 2.21 2.21 0 001.05-2.43v-3.12a2.58 2.58 0 011.21-2.76 2.52 2.52 0 013 .3l2.67 1.55-.18.34-2.69-1.56a2.54 2.54 0 00-2.55-.28 2.59 2.59 0 00-1 2.37v3.12a3 3 0 01-1.22 2.71 2.13 2.13 0 01-1.18.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M230.93 230.9h-.05a4.09 4.09 0 01-2-.62l-12.8-7.46a.4.4 0 01-.17-.23.4.4 0 010-.28l.19-.33a.38.38 0 01.51-.13l12.8 7.47a1.87 1.87 0 002.24.32 1.84 1.84 0 00.87-2v-3.21a2.92 2.92 0 014.8-2.74l2.6 1.51a.36.36 0 01.14.49l-.18.34a.41.41 0 01-.22.19.42.42 0 01-.29 0l-2.68-1.56a1.81 1.81 0 00-3 1.73v3.16a3.32 3.32 0 01-1.37 3 2.5 2.5 0 01-1.39.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-8",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M225.87 233.05a3.62 3.62 0 01-1.83-.57l-12.83-7.57.18-.33 12.83 7.56a2.54 2.54 0 002.57.28 2.64 2.64 0 001.05-2.41v-3.15a3 3 0 011.22-2.76 2.86 2.86 0 012.95.29l2.7 1.63-.19.35-2.69-1.59a2.13 2.13 0 00-2.56-.28 2.26 2.26 0 00-1 2.41V230a3 3 0 01-1.22 2.75 2.18 2.18 0 01-1.18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M225.91 233.42a4.07 4.07 0 01-2-.63L211 225.23a.36.36 0 01-.13-.49l.18-.34a.38.38 0 01.23-.18.35.35 0 01.28 0l12.83 7.56a2.18 2.18 0 002.23.26 2.24 2.24 0 00.83-2v-3.19a3.36 3.36 0 011.37-3.05 3.23 3.23 0 013.39.28l2.67 1.62a.36.36 0 01.13.49l-.19.35a.38.38 0 01-.23.18.39.39 0 01-.28 0l-2.69-1.6a1.81 1.81 0 00-2.19-.27 1.87 1.87 0 00-.86 2V230a3.35 3.35 0 01-1.38 3.05 2.61 2.61 0 01-1.28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-9",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M220.84 236.41a3.62 3.62 0 01-1.83-.57l-12.84-7.47.2-.33 12.83 7.46a2.19 2.19 0 003.6-2.1v-3.14a2.58 2.58 0 011.23-2.73 2.53 2.53 0 013 .27l2.69 1.56-.2.34-2.69-1.57a2.16 2.16 0 00-2.62-.35 2.21 2.21 0 00-1 2.46v3.11a2.91 2.91 0 01-1.22 2.71 2.16 2.16 0 01-1.07.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M220.84 236.78a4 4 0 01-2-.63L206 228.68a.32.32 0 01-.17-.22.35.35 0 010-.28l.19-.33a.35.35 0 01.5-.13l12.84 7.46a1.84 1.84 0 002.19.27 1.82 1.82 0 00.86-2v-3.21a2.93 2.93 0 014.8-2.74l2.63 1.53a.32.32 0 01.17.22.35.35 0 010 .28l-.19.33a.36.36 0 01-.5.13l-2.69-1.56-.08-.06a1.8 1.8 0 00-2.18-.29 1.83 1.83 0 00-.86 2.05v3.2a3.27 3.27 0 01-1.38 3 2.66 2.66 0 01-1.26.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-10",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M216.3 238.93a3.87 3.87 0 01-1.91-.57l-13.25-7.48.2-.35 13.25 7.47a2.28 2.28 0 002.72.36 2.2 2.2 0 001.07-2.47v-3.12a2.57 2.57 0 011.26-2.74 2.69 2.69 0 013.06.27l2.78 1.57-.2.33-2.76-1.56a2.3 2.3 0 00-2.7-.33 2.2 2.2 0 00-1.09 2.44v3.14a2.93 2.93 0 01-1.26 2.73 2.28 2.28 0 01-1.17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M216.36 239.29h-.07a4.18 4.18 0 01-2.09-.62L201 231.2a.38.38 0 01-.18-.23.4.4 0 010-.28l.2-.34a.37.37 0 01.5-.14l13.26 7.49.07.06a1.94 1.94 0 002.28.3A1.81 1.81 0 00218 236a.31.31 0 010-.1v-3.12a2.9 2.9 0 011.45-3.06 3.07 3.07 0 013.48.31l2.72 1.53a.33.33 0 01.17.23.31.31 0 010 .28l-.2.33a.36.36 0 01-.49.13l-2.8-1.53a2 2 0 00-2.33-.33 1.84 1.84 0 00-.91 2v3.23a3.28 3.28 0 01-1.42 3 2.64 2.64 0 01-1.31.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-11",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M210.78 242.28a3.78 3.78 0 01-1.85-.56l-12.83-7.49.2-.34 12.83 7.53a2.49 2.49 0 002.56.28 2.58 2.58 0 001.05-2.37v-3.19a2.6 2.6 0 011.26-2.74 2.55 2.55 0 013 .28l2.67 1.58-.19.33-2.75-1.59a2.19 2.19 0 00-2.61-.33 2.25 2.25 0 00-1.05 2.44v3.13a3 3 0 01-1.22 2.72 2.1 2.1 0 01-1.07.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M210.78 242.65a4.16 4.16 0 01-2-.62l-12.82-7.48a.36.36 0 01-.14-.5l.2-.34a.39.39 0 01.22-.18.38.38 0 01.28 0l12.83 7.53a2.18 2.18 0 002.23.27 2.27 2.27 0 00.84-2v-3.22a2.93 2.93 0 014.8-2.74l2.62 1.54a.36.36 0 01.13.5l-.19.34a.38.38 0 01-.51.13l-2.67-1.57a1.84 1.84 0 00-3.12 1.71v3.21a3.33 3.33 0 01-1.38 3 2.47 2.47 0 01-1.28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-12",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M205.74 244.8a3.74 3.74 0 01-1.84-.56l-12.83-7.49.19-.33 12.83 7.47a2.51 2.51 0 002.57.28 2.63 2.63 0 001.05-2.38v-3.13a2.58 2.58 0 011.22-2.74 2.55 2.55 0 013 .28l2.68 1.56-.19.34-2.68-1.56a2.17 2.17 0 00-2.62-.35 2.21 2.21 0 00-1 2.45v3.13a3 3 0 01-1.23 2.71 2.12 2.12 0 01-1.15.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M205.74 245.17a4.16 4.16 0 01-2-.62l-12.82-7.48a.41.41 0 01-.17-.22.38.38 0 010-.28l.19-.34a.38.38 0 01.51-.13l12.83 7.47a2.16 2.16 0 002.22.27 2.24 2.24 0 00.84-2v-3.17a2.93 2.93 0 014.8-2.74l2.61 1.53a.35.35 0 01.14.49l-.18.33a.38.38 0 01-.23.18.35.35 0 01-.28 0l-2.69-1.55-.07-.06a1.8 1.8 0 00-2.18-.29 1.85 1.85 0 00-.87 2v3.22a3.33 3.33 0 01-1.37 3 2.52 2.52 0 01-1.28.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-13",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M200.72 248.16a3.62 3.62 0 01-1.84-.57L186 240.11l.18-.33 12.85 7.48a2.17 2.17 0 003.59-2.06V242a2.6 2.6 0 011.22-2.74 2.55 2.55 0 013 .27l2.69 1.57-.19.34-2.69-1.56A2.19 2.19 0 00203 242v3.21a3 3 0 01-1.22 2.71 2.22 2.22 0 01-1.1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M200.81 248.53h-.11a4 4 0 01-2-.62l-12.84-7.47a.37.37 0 01-.13-.5l.18-.33a.39.39 0 01.22-.18.42.42 0 01.29 0l12.85 7.48a1.81 1.81 0 003-1.7V242a2.93 2.93 0 014.8-2.74l2.64 1.52a.37.37 0 01.13.5l-.19.35a.4.4 0 01-.23.17.35.35 0 01-.28 0l-2.69-1.56a1.83 1.83 0 00-3.05 1.76v3.25a3.31 3.31 0 01-1.38 3 2.5 2.5 0 01-1.21.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-14",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M195.63 250.68a3.63 3.63 0 01-1.83-.58l-12.8-7.56.2-.34 12.8 7.54a2.14 2.14 0 002.62.36 2.26 2.26 0 001-2.49v-3.13a3 3 0 011.22-2.75 2.82 2.82 0 012.93.29l2.69 1.57-.2.35-2.68-1.59a2.14 2.14 0 00-2.56-.27 2.23 2.23 0 00-1 2.4v3.16a3 3 0 01-1.22 2.75 2.32 2.32 0 01-1.17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M195.71 251.05h-.1a3.9 3.9 0 01-2-.63l-12.79-7.55a.36.36 0 01-.13-.5l.19-.34a.36.36 0 01.5-.13l12.82 7.53.08.06a1.78 1.78 0 002.17.31 1.89 1.89 0 00.86-2.09v-3.22a3.37 3.37 0 011.37-3 3.22 3.22 0 013.38.29l2.64 1.55a.38.38 0 01.14.5l-.2.34a.39.39 0 01-.22.18.37.37 0 01-.29 0l-2.68-1.58a1.82 1.82 0 00-2.18-.28 1.86 1.86 0 00-.86 2v3.23a3.35 3.35 0 01-1.37 3.05 2.61 2.61 0 01-1.33.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-15",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M190.63 254a3.65 3.65 0 01-1.84-.57L176 246l.19-.35 12.81 7.48a2.17 2.17 0 002.57.28 2.23 2.23 0 001-2.39v-3.12a2.57 2.57 0 011.22-2.74 2.53 2.53 0 013 .27l2.69 1.57-.2.33-2.67-1.57a2.54 2.54 0 00-2.6-.24 2.57 2.57 0 00-1.05 2.38v3.1a3 3 0 01-1.22 2.73 2.31 2.31 0 01-1.09.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M190.63 254.4a4 4 0 01-2-.62l-12.82-7.48a.37.37 0 01-.13-.5l.19-.34a.33.33 0 01.23-.17.35.35 0 01.28 0l12.83 7.5a1.83 1.83 0 003.06-1.72v-3.2a2.93 2.93 0 014.79-2.75l2.63 1.53a.38.38 0 01.14.5l-.2.34a.41.41 0 01-.22.17.38.38 0 01-.28 0l-2.68-1.57a2.16 2.16 0 00-2.25-.23 2.2 2.2 0 00-.85 2V251a3.35 3.35 0 01-1.38 3 2.58 2.58 0 01-1.29.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-16",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M185.57 256.55a3.73 3.73 0 01-1.84-.55l-12.81-7.5.2-.34 12.8 7.49a2.16 2.16 0 002.61.33 2.25 2.25 0 001.05-2.44v-3.12a2.59 2.59 0 011.22-2.75 2.53 2.53 0 012.95.28l2.67 1.57-.19.33-2.77-1.54a2.15 2.15 0 00-2.6-.33 2.22 2.22 0 00-1.05 2.44v3.11a3 3 0 01-1.22 2.73 2.15 2.15 0 01-1 .29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M185.57 256.92a4 4 0 01-2-.61l-12.79-7.49a.36.36 0 01-.14-.5l.2-.34a.36.36 0 01.22-.18.38.38 0 01.28 0l12.81 7.5a1.85 1.85 0 002.23.32 1.88 1.88 0 00.88-2v-3.2a2.93 2.93 0 014.79-2.75l2.61 1.53a.37.37 0 01.13.5l-.19.34a.37.37 0 01-.5.13l-2.77-1.54-.07-.06a1.81 1.81 0 00-2.17-.27 1.86 1.86 0 00-.87 2v3.2a3.32 3.32 0 01-1.37 3 2.5 2.5 0 01-1.22.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-17",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M180.53 259.07a3.75 3.75 0 01-1.84-.57l-12.8-7.5.19-.34 12.8 7.48a2.17 2.17 0 002.62.35 2.21 2.21 0 001-2.45v-3.13a2.61 2.61 0 011.22-2.74 2.52 2.52 0 013 .28l2.67 1.56-.19.33-2.66-1.52a2.52 2.52 0 00-2.56-.29 2.63 2.63 0 00-1.1 2.38v3.13a3 3 0 01-1.22 2.72 2.12 2.12 0 01-1.13.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M180.58 259.44h-.07a4.19 4.19 0 01-2-.62l-12.8-7.48a.38.38 0 01-.14-.5l.2-.35a.41.41 0 01.22-.17.37.37 0 01.29 0l12.8 7.48.08.06a1.8 1.8 0 002.17.3 1.86 1.86 0 00.86-2.05v-3.22a3 3 0 011.4-3.06 2.91 2.91 0 013.39.32l2.61 1.52a.38.38 0 01.14.5l-.18.33a.38.38 0 01-.23.18.35.35 0 01-.28 0l-2.67-1.53a2.16 2.16 0 00-2.22-.26 2.21 2.21 0 00-.88 2v3.16a3.33 3.33 0 01-1.37 3 2.52 2.52 0 01-1.32.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-18",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M175.47 262.43a3.72 3.72 0 01-1.83-.57l-12.79-7.48.15-.38 12.81 7.48a2.15 2.15 0 002.61.35 2.21 2.21 0 001-2.45v-3.13a2.61 2.61 0 011.22-2.74 2.53 2.53 0 013 .27l2.67 1.57-.18.33-2.68-1.55a2.17 2.17 0 00-2.62-.36 2.23 2.23 0 00-1 2.45v3.14a2.93 2.93 0 01-1.22 2.71 2.18 2.18 0 01-1.14.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M175.49 262.8a4.06 4.06 0 01-2-.63l-12.79-7.47a.44.44 0 01-.17-.23.4.4 0 010-.28l.2-.33a.35.35 0 01.5-.13L174 261.2a.24.24 0 01.08.06 1.79 1.79 0 002.17.29 1.85 1.85 0 00.87-2v-3.22a2.92 2.92 0 011.4-3.06 2.88 2.88 0 013.38.32l2.62 1.52a.37.37 0 01.13.5l-.18.33a.39.39 0 01-.22.18.42.42 0 01-.29 0l-2.68-1.55-.07-.06a1.81 1.81 0 00-2.17-.3 1.86 1.86 0 00-.87 2.05v3.22a3.3 3.3 0 01-1.37 3 2.51 2.51 0 01-1.31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-19",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M170.12 265a3.94 3.94 0 01-1.89-.57L155 256.89l.19-.34 13.27 7.52a2.31 2.31 0 002.72.36 2.2 2.2 0 001.06-2.48v-3.13a2.58 2.58 0 011.27-2.75 2.69 2.69 0 013.06.27l2.77 1.58-.2.34-2.77-1.57a2.3 2.3 0 00-2.72-.36 2.22 2.22 0 00-1.07 2.48v3.13a2.9 2.9 0 01-1.26 2.72 2.26 2.26 0 01-1.2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M170.19 265.31h-.08a4.17 4.17 0 01-2.07-.62l-13.25-7.48a.41.41 0 01-.17-.22.38.38 0 010-.28l.19-.34a.41.41 0 01.22-.17.38.38 0 01.28 0l13.27 7.52.08.05a1.91 1.91 0 002.28.3 1.83 1.83 0 00.89-2.06.28.28 0 010-.09v-3.13a2.9 2.9 0 011.45-3.07 3.05 3.05 0 013.48.31l2.72 1.54a.35.35 0 01.17.22.35.35 0 010 .28l-.2.35a.37.37 0 01-.5.13l-2.79-1.55-.08-.06a1.94 1.94 0 00-2.28-.3 1.84 1.84 0 00-.89 2.06.31.31 0 010 .1v3.13a3.24 3.24 0 01-1.42 3 2.6 2.6 0 01-1.3.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-20",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M165.42 268.3a3.62 3.62 0 01-1.83-.57l-12.81-7.56.19-.34 12.81 7.56a2.15 2.15 0 002.63.36 2.25 2.25 0 001-2.49v-3.15a3 3 0 011.22-2.75 2.82 2.82 0 012.94.28l2.68 1.57-.2.35-2.64-1.56a2.52 2.52 0 00-2.56-.28 2.61 2.61 0 00-1 2.41v3.15a3 3 0 01-1.22 2.76 2.3 2.3 0 01-1.17.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M165.48 268.67h-.08a3.9 3.9 0 01-2-.63l-12.8-7.56a.37.37 0 01-.13-.5l.19-.33a.38.38 0 01.23-.18.4.4 0 01.28 0l12.83 7.61a.21.21 0 01.08.06 1.79 1.79 0 002.17.3 1.89 1.89 0 00.86-2.09v-3.24a3.36 3.36 0 011.37-3.05 3.19 3.19 0 013.38.29l2.64 1.55a.35.35 0 01.14.49l-.2.35a.36.36 0 01-.22.18.38.38 0 01-.28 0l-2.67-1.58A2.16 2.16 0 00169 260a2.25 2.25 0 00-.84 2v3.19a3.34 3.34 0 01-1.37 3.05 2.58 2.58 0 01-1.31.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-21",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M160.06 270.82a3.87 3.87 0 01-1.9-.57l-13.26-7.57.2-.34 13.26 7.57a2.27 2.27 0 002.71.36 2.22 2.22 0 001.07-2.49v-3.16a3 3 0 011.26-2.76 3.11 3.11 0 013.06.29l2.78 1.59-.2.33-2.76-1.58a2.28 2.28 0 00-2.7-.33 2.22 2.22 0 00-1.08 2.46v3.16a3 3 0 01-1.27 2.76 2.38 2.38 0 01-1.17.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M160.1 271.19a4.19 4.19 0 01-2.09-.63L144.72 263a.32.32 0 01-.17-.22.34.34 0 010-.28l.2-.34a.37.37 0 01.5-.13l13.25 7.57.08.06a1.91 1.91 0 002.27.3 1.85 1.85 0 00.9-2.08.29.29 0 010-.09v-3.16a3.33 3.33 0 011.42-3.06 3.51 3.51 0 013.48.29l2.75 1.57a.36.36 0 01.18.22.38.38 0 010 .28l-.2.34a.37.37 0 01-.5.13l-2.76-1.58a2 2 0 00-2.34-.33 1.87 1.87 0 00-.91 2.06v3.24a3.32 3.32 0 01-1.42 3.06 2.82 2.82 0 01-1.35.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-22",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M277.14 216.26A2.16 2.16 0 01276 216a3 3 0 01-1.22-2.74v-3.13a2.24 2.24 0 00-1.05-2.44 2.16 2.16 0 00-2.61.33l-2.67 1.57-.19-.34 2.67-1.57a2.53 2.53 0 013-.27 2.61 2.61 0 011.22 2.75v3.13a2.23 2.23 0 001.05 2.45 2.18 2.18 0 002.6-.33l12.8-7.54.2.34-12.8 7.49a3.67 3.67 0 01-1.86.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M277.12 216.51a2.46 2.46 0 01-1.21-.32 3.23 3.23 0 01-1.35-3v-3.11a2 2 0 00-.92-2.23 2 2 0 00-2.32.29l-2.93 1.73-.44-.75 2.88-1.7a2.75 2.75 0 013.21-.28 2.88 2.88 0 011.34 3v3.09a2 2 0 00.93 2.23 1.94 1.94 0 002.31-.29l13.06-7.7.44.77-.21.13-12.81 7.5a3.86 3.86 0 01-2 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-23",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M281.33 218.78a2.16 2.16 0 01-1.11-.28 3 3 0 01-1.22-2.74v-3.13a2.25 2.25 0 00-1.05-2.45 2.16 2.16 0 00-2.6.33l-2.68 1.58-.19-.34 2.67-1.57a2.55 2.55 0 013-.28 2.63 2.63 0 011.22 2.75v3.14a2.23 2.23 0 001.05 2.44 2.15 2.15 0 002.6-.33l12.81-7.51.19.35-12.8 7.51a3.67 3.67 0 01-1.89.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M281.28 219a2.32 2.32 0 01-1.18-.32 3.24 3.24 0 01-1.34-3v-3.11a2 2 0 00-.93-2.23 1.92 1.92 0 00-2.31.29l-2.95 1.73-.42-.76L275 210a2.74 2.74 0 013.2-.28 2.87 2.87 0 011.34 3v3.09a2 2 0 00.92 2.23 1.93 1.93 0 002.31-.29l13.07-7.68.44.78-13 7.63a4 4 0 01-2 .57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-24",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M286.33 222.14a2.18 2.18 0 01-1.11-.3 3 3 0 01-1.22-2.71V216a2.62 2.62 0 00-1-2.38 2.5 2.5 0 00-2.55.28l-2.71 1.55-.18-.34 2.67-1.57a2.52 2.52 0 012.95-.27 2.6 2.6 0 011.23 2.74v3.14a2.21 2.21 0 001 2.45 2.15 2.15 0 002.61-.35l12.81-7.48.19.33-12.87 7.52a3.77 3.77 0 01-1.82.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M286.3 222.39a2.38 2.38 0 01-1.21-.34 3.2 3.2 0 01-1.33-3V216a2.38 2.38 0 00-.94-2.18 2.26 2.26 0 00-2.27.28l-2.94 1.68-.42-.76 2.87-1.69a2.77 2.77 0 013.21-.27 2.85 2.85 0 011.34 3v3.09a2 2 0 00.92 2.24 1.92 1.92 0 002.32-.31l13-7.61.45.76-13.08 7.64a4.05 4.05 0 01-1.95.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-25",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M291.38 224.66a2.15 2.15 0 01-1.11-.3 3 3 0 01-1.23-2.72v-3.14a2.2 2.2 0 00-1-2.37 2.17 2.17 0 00-2.56.27l-2.73 1.6-.2-.34 2.69-1.57a2.55 2.55 0 013-.27 2.61 2.61 0 011.23 2.75v3.14a2.57 2.57 0 001.05 2.38 2.48 2.48 0 002.55-.28l12.83-7.49.19.33-12.85 7.5a3.69 3.69 0 01-1.86.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M291.35 224.9a2.37 2.37 0 01-1.21-.33 3.18 3.18 0 01-1.34-2.95v-3.12a2 2 0 00-.93-2.16 1.9 1.9 0 00-2.26.24l-2.95 1.71-.44-.75 2.9-1.7a2.78 2.78 0 013.22-.27 2.86 2.86 0 011.34 3v3.1a2.37 2.37 0 00.95 2.18 2.21 2.21 0 002.26-.28l13.11-7.63.42.76-13.05 7.63a4.09 4.09 0 01-1.95.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-26",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M296.7 228a2.3 2.3 0 01-1.15-.3 2.9 2.9 0 01-1.26-2.72v-3.13a2.53 2.53 0 00-1.09-2.38 2.68 2.68 0 00-2.65.27l-2.76 1.57-.2-.35 2.78-1.57a2.69 2.69 0 013.06-.27 2.57 2.57 0 011.26 2.74V225a2.2 2.2 0 001.07 2.47 2.3 2.3 0 002.72-.35l13.25-7.51.2.34-13.34 7.49a3.94 3.94 0 01-1.89.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M296.66 228.26a2.41 2.41 0 01-1.23-.33 3.14 3.14 0 01-1.38-3v-3.1a2.3 2.3 0 00-1-2.18 2.42 2.42 0 00-2.36.27l-3 1.7-.44-.77 3-1.69a2.94 2.94 0 013.31-.28 2.82 2.82 0 011.38 3v3.14a2 2 0 00.95 2.2 2 2 0 002.42-.32h.05l13.47-7.62.45.75-13.56 7.62a4 4 0 01-2 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-27",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M301.78 230.53a2.27 2.27 0 01-1.14-.28 3 3 0 01-1.27-2.73v-3.13a2.19 2.19 0 00-1.08-2.44 2.3 2.3 0 00-2.7.33l-2.76 1.57-.2-.35 2.76-1.56a2.69 2.69 0 013.07-.29 2.58 2.58 0 011.27 2.76v3.06a2.18 2.18 0 001.07 2.47 2.28 2.28 0 002.71-.36l13.26-7.5.2.33-13.28 7.53a3.79 3.79 0 01-1.91.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M301.77 230.78a2.58 2.58 0 01-1.25-.32 3.19 3.19 0 01-1.39-3v-3.1a2 2 0 00-1-2.23 2.08 2.08 0 00-2.41.29l-3 1.73-.45-.77 3-1.68a2.9 2.9 0 013.32-.29 2.82 2.82 0 011.38 3v3.07a2 2 0 001 2.2 2.06 2.06 0 002.42-.32h.05l13.46-7.62.46.75-13.5 7.65a4.1 4.1 0 01-2 .63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-28",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M306.51 233.05a2.29 2.29 0 01-1.11-.28 3 3 0 01-1.22-2.74v-3.13a2.24 2.24 0 00-1-2.45 2.18 2.18 0 00-2.61.33l-2.67 1.57-.2-.33 2.67-1.57a2.52 2.52 0 013-.28 2.6 2.6 0 011.22 2.75v3.14a2.25 2.25 0 001.05 2.44 2.16 2.16 0 002.61-.33L321 224.6l.2.33-12.82 7.51a3.57 3.57 0 01-1.84.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M306.5 233.3a2.47 2.47 0 01-1.22-.32 3.26 3.26 0 01-1.34-3v-3.08a2.05 2.05 0 00-.93-2.24 1.92 1.92 0 00-2.31.3l-2.93 1.73-.44-.76 2.88-1.69a2.75 2.75 0 013.21-.28 2.85 2.85 0 011.33 3v3.09a2 2 0 00.93 2.23A1.94 1.94 0 00308 232l13.06-7.74.44.76-13 7.64a4 4 0 01-2 .64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-29",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M311.54 236.41a2 2 0 01-1.1-.29 2.94 2.94 0 01-1.22-2.72v-3.14a2.25 2.25 0 00-1.05-2.45 2.16 2.16 0 00-2.61.33l-2.68 1.57-.18-.33 2.67-1.57a2.52 2.52 0 013-.28 2.62 2.62 0 011.22 2.75v3.15a2.24 2.24 0 001.05 2.43 2.18 2.18 0 002.6-.33L326 228l.19.34-12.8 7.52a3.81 3.81 0 01-1.86.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M311.5 236.65a2.45 2.45 0 01-1.19-.31 3.24 3.24 0 01-1.34-3v-3.11a2 2 0 00-.92-2.24 2 2 0 00-2.32.29l-2.94 1.74-.42-.76 2.87-1.7a2.77 2.77 0 013.21-.27 2.87 2.87 0 011.34 3v3.1a2 2 0 00.94 2.22 1.91 1.91 0 002.3-.3l13.07-7.67.43.77-13 7.64a4 4 0 01-2 .56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-30",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M316.53 238.93a2.18 2.18 0 01-1.11-.3 3 3 0 01-1.22-2.72v-3.14a2.63 2.63 0 00-1-2.39 2.52 2.52 0 00-2.56.29l-2.68 1.56-.19-.34 2.68-1.57a2.52 2.52 0 012.95-.27 2.59 2.59 0 011.22 2.75v3.11a2.23 2.23 0 001.05 2.46 2.15 2.15 0 002.61-.36l12.8-7.49.19.33-12.81 7.51a3.77 3.77 0 01-1.93.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M316.51 239.17a2.34 2.34 0 01-1.21-.33 3.22 3.22 0 01-1.34-3v-3.11a2.41 2.41 0 00-.94-2.19 2.26 2.26 0 00-2.26.28l-2.92 1.7-.44-.75 2.89-1.7a2.75 2.75 0 013.21-.27 2.85 2.85 0 011.34 3v3.07a2 2 0 00.92 2.25 1.93 1.93 0 002.32-.32h.05l13-7.62.42.77-13 7.62a3.93 3.93 0 01-2 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-31",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M321.59 242.28a2.05 2.05 0 01-1.11-.29 3 3 0 01-1.23-2.72v-3.14a2.62 2.62 0 00-1-2.39 2.53 2.53 0 00-2.57.29l-2.68 1.55-.2-.33 2.69-1.57a2.55 2.55 0 013-.28 2.62 2.62 0 011.23 2.75v3.14a2.21 2.21 0 001 2.39 2.19 2.19 0 002.57-.27l12.83-7.51.19.34-12.83 7.5a3.68 3.68 0 01-1.89.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M321.55 242.53a2.31 2.31 0 01-1.2-.33 3.23 3.23 0 01-1.34-3v-3.11a2.41 2.41 0 00-.94-2.19 2.28 2.28 0 00-2.27.28l-2.92 1.7-.44-.76 2.89-1.69a2.77 2.77 0 013.22-.28 2.87 2.87 0 011.34 3v3.09a2 2 0 00.92 2.18 1.92 1.92 0 002.27-.24l13.09-7.66.44.75-13 7.63a4.07 4.07 0 01-2 .58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-32",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M327.37 244.8a2 2 0 01-1.1-.3 3 3 0 01-1.22-2.74v-3.15a2.29 2.29 0 00-1.05-2.47 2.16 2.16 0 00-2.61.34l-2.55 1.58-.19-.35 2.68-1.57a2.84 2.84 0 012.94-.29 3 3 0 011.22 2.76v3.15a2.22 2.22 0 001 2.49 2.14 2.14 0 002.62-.36l12.89-7.56.2.33-12.81 7.57a3.54 3.54 0 01-2 .57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M327.36 245.05a2.39 2.39 0 01-1.22-.34 3.27 3.27 0 01-1.34-3v-3.13a2 2 0 00-.93-2.25 1.91 1.91 0 00-2.31.29l-2.81 1.75-.43-.78 2.89-1.69a3 3 0 013.16-.3 3.26 3.26 0 011.36 3v3.13a2 2 0 00.91 2.28 1.91 1.91 0 002.33-.32L342 236l.44.76-13 7.69a3.77 3.77 0 01-2.07.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-33",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M332 248.16a2.49 2.49 0 01-1.14-.28 2.94 2.94 0 01-1.26-2.74V242a2.21 2.21 0 00-1.09-2.45 2.3 2.3 0 00-2.69.33l-2.77 1.57-.21-.34 2.76-1.56a2.67 2.67 0 013.06-.28 2.57 2.57 0 011.26 2.75v3.13a2.22 2.22 0 001.09 2.45 2.28 2.28 0 002.69-.33l13.3-7.53.2.34-13.24 7.51a3.78 3.78 0 01-1.94.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M332 248.4a2.57 2.57 0 01-1.25-.31 3.21 3.21 0 01-1.39-3V242a2 2 0 00-1-2.24 2.06 2.06 0 00-2.4.3l-3 1.73-.45-.77 3-1.69a2.91 2.91 0 013.3-.27 2.82 2.82 0 011.38 3v3.08a2 2 0 001 2.24 2.07 2.07 0 002.41-.3l13.53-7.69.45.76-13.46 7.63a4 4 0 01-2.05.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-34",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M337 250.68a2.21 2.21 0 01-1.15-.29 3 3 0 01-1.26-2.74v-3.1a2.22 2.22 0 00-1.08-2.45 2.31 2.31 0 00-2.7.33l-2.74 1.57-.19-.34 2.8-1.59a2.67 2.67 0 013.06-.28 2.59 2.59 0 011.26 2.75v3.1a2.22 2.22 0 001.08 2.45 2.3 2.3 0 002.7-.33l13.22-7.51.2.35-13.2 7.51a3.85 3.85 0 01-2 .57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M337 250.92a2.57 2.57 0 01-1.22-.31 3.2 3.2 0 01-1.38-3v-3.08a2 2 0 00-1-2.23 2.05 2.05 0 00-2.41.29l-3 1.73-.43-.76 3-1.72a2.91 2.91 0 013.3-.27 2.83 2.83 0 011.38 3v3.05a2 2 0 001 2.24 2.07 2.07 0 002.41-.3l13.5-7.67.45.77-13.46 7.63a4 4 0 01-2.07.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-35",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M342.63 254a2.06 2.06 0 01-1.11-.28 3 3 0 01-1.22-2.72v-3.15a2.23 2.23 0 00-1-2.47 2.14 2.14 0 00-2.62.36l-2.68 1.6-.19-.34 2.68-1.57a2.55 2.55 0 013-.27 2.61 2.61 0 011.22 2.75v3.14a2.19 2.19 0 003.61 2.11l12.83-7.52.19.35-12.83 7.51a3.73 3.73 0 01-1.88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M342.58 254.28a2.35 2.35 0 01-1.18-.32 3.19 3.19 0 01-1.34-3v-3.12a2 2 0 00-.91-2.26 1.91 1.91 0 00-2.33.32h-.05l-2.9 1.69-.44-.75 2.9-1.7a2.74 2.74 0 013.21-.27 2.87 2.87 0 011.34 3v3.09a2.38 2.38 0 00.95 2.19 2.35 2.35 0 002.28-.28l13.07-7.66.41.78-13 7.63a3.94 3.94 0 01-1.91.57h-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-36",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M347.63 256.55a2 2 0 01-1.11-.3 3 3 0 01-1.22-2.73v-3.16a2.25 2.25 0 00-1.07-2.38 2.16 2.16 0 00-2.56.31l-2.67 1.58-.2-.34 2.69-1.58a2.52 2.52 0 013-.27 2.6 2.6 0 011.22 2.76v3.16a2.65 2.65 0 001 2.39 2.51 2.51 0 002.57-.28l12.83-7.55.19.35-12.83 7.55a3.69 3.69 0 01-1.83.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M347.6 256.8a2.44 2.44 0 01-1.21-.33 3.25 3.25 0 01-1.34-3v-3.14a2 2 0 00-.94-2.17 1.91 1.91 0 00-2.27.28l-2.94 1.73-.44-.76 2.89-1.7a2.75 2.75 0 013.22-.27 2.85 2.85 0 011.33 3v3.11a2.43 2.43 0 00.94 2.2 2.26 2.26 0 002.27-.29l13.07-7.68.43.77-13 7.67a4.11 4.11 0 01-2 .53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-37",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M352.69 259.91a2.18 2.18 0 01-1.11-.3 3 3 0 01-1.22-2.71v-3.15a2.22 2.22 0 00-1-2.46 2.18 2.18 0 00-2.62.36L344 253.2l-.19-.33 2.68-1.57a2.55 2.55 0 013-.27 2.61 2.61 0 011.22 2.74v3.13a2.22 2.22 0 001 2.38 2.16 2.16 0 002.56-.27l12.83-7.48.2.33-12.76 7.48a3.7 3.7 0 01-1.88.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M352.67 260.16a2.47 2.47 0 01-1.21-.33 3.25 3.25 0 01-1.35-2.95v-3.13a2 2 0 00-.92-2.24 1.92 1.92 0 00-2.32.31h-.05l-2.89 1.68-.44-.76 2.9-1.69a2.77 2.77 0 013.21-.27 2.84 2.84 0 011.34 3v3.08a2 2 0 00.91 2.17 1.93 1.93 0 002.28-.24l13.08-7.64.44.76-.21.12-12.75 7.49a4.13 4.13 0 01-2 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-38",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M357.71 262.43a2.18 2.18 0 01-1.11-.3 3 3 0 01-1.21-2.74v-3.16a2.27 2.27 0 00-1.05-2.46 2.16 2.16 0 00-2.61.33l-2.67 1.59-.2-.35 2.67-1.57a2.86 2.86 0 013-.29 3 3 0 011.22 2.75v3.16a2.27 2.27 0 001.05 2.46 2.16 2.16 0 002.61-.33l12.76-7.52.2.34-12.82 7.57a3.62 3.62 0 01-1.84.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M357.69 262.67a2.34 2.34 0 01-1.21-.33 3.25 3.25 0 01-1.34-3v-3.13a2.07 2.07 0 00-.93-2.25 1.92 1.92 0 00-2.31.3L349 256l-.44-.78 2.88-1.69a3.07 3.07 0 013.18-.3 3.28 3.28 0 011.36 3v3.13a2.06 2.06 0 00.92 2.25 1.94 1.94 0 002.32-.3l13.07-7.72.44.76-13 7.69a3.86 3.86 0 01-2 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-39",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M362.75 265.79a2.27 2.27 0 01-1.11-.29 3 3 0 01-1.22-2.75v-3.16a2.25 2.25 0 00-1.05-2.46 2.17 2.17 0 00-2.61.33l-2.68 1.54-.18-.35 2.67-1.57a2.84 2.84 0 012.95-.28 3 3 0 011.22 2.75v3.16a2.26 2.26 0 001.05 2.46 2.17 2.17 0 002.61-.33l12.81-7.57.19.34-12.81 7.56a3.57 3.57 0 01-1.84.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M362.73 266a2.46 2.46 0 01-1.21-.32 3.26 3.26 0 01-1.34-3v-3.13a2.07 2.07 0 00-.93-2.25 1.89 1.89 0 00-2.31.3l-2.94 1.79-.42-.79 2.87-1.69a3.08 3.08 0 013.19-.29 3.26 3.26 0 011.35 3v3.13a2.07 2.07 0 00.93 2.25 1.92 1.92 0 002.31-.3l13.06-7.7.45.76-13 7.69a3.77 3.77 0 01-1.95.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-40",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M367.8 268.3a2.16 2.16 0 01-1.11-.28 3 3 0 01-1.22-2.74v-3.13a2.22 2.22 0 00-1-2.47 2.16 2.16 0 00-2.63.36l-2.68 1.57-.18-.34 2.67-1.57a2.53 2.53 0 013-.27 2.6 2.6 0 011.23 2.75v3.13a2.57 2.57 0 001.05 2.39 2.54 2.54 0 002.56-.27l12.83-7.52.2.35-12.85 7.5a3.57 3.57 0 01-1.79.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M367.78 268.55a2.46 2.46 0 01-1.21-.32 3.23 3.23 0 01-1.35-3v-3.11a2 2 0 00-.91-2.26 1.91 1.91 0 00-2.33.32h-.05L359 262l-.42-.77 2.88-1.69a2.75 2.75 0 013.21-.28 2.88 2.88 0 011.34 3v3.09a2.38 2.38 0 00.95 2.19 2.3 2.3 0 002.28-.27l13.06-7.66.44.78-13 7.62a3.81 3.81 0 01-1.91.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-41",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M372.79 271.66a2.13 2.13 0 01-1.11-.28 3 3 0 01-1.23-2.74v-3.13a2.21 2.21 0 00-1-2.39 2.17 2.17 0 00-2.57.27l-2.71 1.61-.2-.33 2.69-1.57a2.52 2.52 0 013-.28 2.62 2.62 0 011.23 2.75v3.16a2.21 2.21 0 001 2.39 2.19 2.19 0 002.57-.27l12.84-7.52.18.35-12.85 7.53a3.69 3.69 0 01-1.83.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M372.74 271.91a2.36 2.36 0 01-1.19-.32 3.23 3.23 0 01-1.34-3v-3.11a2 2 0 00-.92-2.18 1.92 1.92 0 00-2.27.24l-2.94 1.73-.44-.76 2.89-1.69a2.77 2.77 0 013.22-.28 2.87 2.87 0 011.34 3v3.11a2 2 0 00.92 2.18 1.92 1.92 0 002.27-.24l13.11-7.59.41.78-13.06 7.65a4 4 0 01-1.95.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-42",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-3",
    d: "M366.49 264.96v11.61l-99.88 58.04-99.89-58.04v-11.62l199.77.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-43",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M278.76 340.62a8.93 8.93 0 01-4-6.95v-3.12a8.47 8.47 0 00-3.81-6.64l-2.67-1.56.19-.33 2.67 1.56a8.85 8.85 0 014 6.94v3.2a8.44 8.44 0 003.81 6.6l12.83 7.44-.2.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M291.79 348.18l-.4-.28.05-.06-12.61-7.31-.19.29a9.22 9.22 0 01-4.11-7.14v-3.13a8.19 8.19 0 00-3.69-6.43l-2.84-1.68.44-.75 2.89 1.68a9.12 9.12 0 014.11 7.13v3.22a8.26 8.26 0 003.7 6.4l13.05 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-44",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M295.79 344.69L283 337.24a8.85 8.85 0 01-4-7v-3.1a8.52 8.52 0 00-3.81-6.63l-2.71-1.51.19-.34 2.68 1.55a8.88 8.88 0 014 7v3.1a8.52 8.52 0 003.81 6.63l12.84 7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M295.88 345l-13.05-7.57a9.16 9.16 0 01-4.11-7.15v-3.12a8.22 8.22 0 00-3.7-6.42l-2.86-1.66.41-.77 2.9 1.68a9.17 9.17 0 014.12 7.16v3.11a8.22 8.22 0 003.7 6.42l13 7.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-45",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M301 341.84l-.19.33-12.81-7.45a8.86 8.86 0 01-4-7v-3.12a8.48 8.48 0 00-3.8-6.61l-2.67-1.56.18-.33 2.69 1.54a9 9 0 014 7v3.12a8.49 8.49 0 003.8 6.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M300.91 342.5l-.21-.12-12.83-7.45a9.15 9.15 0 01-4.13-7.15v-3.13a8.23 8.23 0 00-3.68-6.41l-2.87-1.67.42-.76 2.9 1.67a9.22 9.22 0 014.11 7.16v3.13a8.29 8.29 0 003.69 6.41l-.21.32 12.61 7.32.07-.12.42.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-46",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M305.87 338.81L293 331.36a8.9 8.9 0 01-4-6.95v-3.11a8.43 8.43 0 00-3.8-6.62l-2.69-1.56.2-.33 2.69 1.56a8.9 8.9 0 014 6.95v3.11a8.48 8.48 0 003.8 6.61l12.83 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M306 339.15l-13.06-7.57a9.23 9.23 0 01-4.12-7.16v-3.12a8.22 8.22 0 00-3.68-6.42l-2.89-1.67.44-.75 2.9 1.68a9.16 9.16 0 014.11 7.15v3.12a8.25 8.25 0 003.69 6.4l13 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-47",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M298.07 328.84a8.88 8.88 0 01-4-6.95v-3.11a8.46 8.46 0 00-3.79-6.62l-2.69-1.56.2-.33 2.67 1.55a8.87 8.87 0 014 7v3.11a8.48 8.48 0 003.8 6.62l12.83 7.45-.19.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M311.11 336.42l-.42-.25.07-.12-12.62-7.33-.21.33a9.17 9.17 0 01-4.1-7.14v-3.13a8.22 8.22 0 00-3.69-6.41l-2.88-1.68.44-.75 2.88 1.67a9.18 9.18 0 014.13 7.15v3.13a8.26 8.26 0 003.69 6.42l13 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-48",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M315.93 332.93l-12.83-7.44a9 9 0 01-4-7v-3.09a8.46 8.46 0 00-3.81-6.62l-2.67-1.53.19-.34 2.68 1.56a8.89 8.89 0 014 7v3.12a8.48 8.48 0 003.8 6.62l12.83 7.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M316 333.26l-13-7.56a9.22 9.22 0 01-4.11-7.16v-3.14a8.26 8.26 0 00-3.7-6.41l-2.88-1.66.45-.75 2.88 1.68a9.18 9.18 0 014.13 7.15v3.14a8.25 8.25 0 003.68 6.42l13 7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-49",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M308.14 323a8.84 8.84 0 01-4-7v-3.1a8.52 8.52 0 00-3.81-6.62l-2.68-1.55.2-.34 2.67 1.55a8.88 8.88 0 014 7V316a8.49 8.49 0 003.81 6.63l12.84 7.45-.18.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M321.21 330.53l-.43-.23.06-.12-12.63-7.33-.21.32a9.14 9.14 0 01-4.1-7.14v-3.12a8.27 8.27 0 00-3.7-6.42l-2.87-1.66.44-.77 2.89 1.68a9.16 9.16 0 014.11 7.16v3.1a8.21 8.21 0 003.7 6.42l13 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-50",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M326 327.06l-12.84-7.45a8.87 8.87 0 01-4-6.95v-3.12a8.46 8.46 0 00-3.81-6.61l-2.67-1.56.18-.33 2.69 1.56a8.9 8.9 0 014 6.94v3.12a8.46 8.46 0 003.81 6.62l12.83 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M326.09 327.39l-13-7.57a9.12 9.12 0 01-4.11-7.14v-3.14a8.29 8.29 0 00-3.7-6.41l-2.87-1.67.42-.76 2.9 1.69a9.16 9.16 0 014.12 7.14v3.13a8.22 8.22 0 003.69 6.41l13 7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-51",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M318.22 317.09a8.86 8.86 0 01-4-6.95V307a8.43 8.43 0 00-3.8-6.62l-2.68-1.55.19-.34 2.69 1.56a8.9 8.9 0 014 6.95v3.11a8.49 8.49 0 003.8 6.62l12.83 7.44-.19.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M331.27 324.66l-.43-.23.07-.14L318.3 317l-.21.32a9.16 9.16 0 01-4.12-7.15V307a8.22 8.22 0 00-3.68-6.42L307.4 299l.44-.78 2.9 1.69a9.16 9.16 0 014.11 7.15v3.12a8.33 8.33 0 003.69 6.42l13 7.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-52",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M336.85 321.18l-13.26-7.45a8.82 8.82 0 01-4.12-6.94v-3.12a8.44 8.44 0 00-3.92-6.62l-2.78-1.56.2-.33 2.78 1.55a8.86 8.86 0 014.12 7v3.12a8.42 8.42 0 003.92 6.61l13.32 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M336.91 321.5l-.18-.1-13.26-7.4a9.15 9.15 0 01-4.25-7.15v-3.13a8.19 8.19 0 00-3.81-6.41l-3-1.68.46-.75 3 1.67a9.15 9.15 0 014.25 7.15v3.14a8.19 8.19 0 003.81 6.41l13.55 7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-53",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M341.31 318.32l-.15.35-12.86-7.45a8.94 8.94 0 01-4-7v-3.1a8.49 8.49 0 00-3.8-6.63l-2.69-1.49.19-.33 2.68 1.55a8.91 8.91 0 014 7v3.1a8.43 8.43 0 003.8 6.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M341.28 319l-13.1-7.59a9.2 9.2 0 01-4.12-7.15v-3.12a8.24 8.24 0 00-3.7-6.42l-2.89-1.68.45-.75 2.89 1.68a9.18 9.18 0 014.13 7.16v3.11a8.22 8.22 0 003.69 6.41l-.21.33 12.61 7.3v-.08l.46.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-54",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M347 315.31l-12.83-7.45a8.88 8.88 0 01-4-7v-3.11a8.47 8.47 0 00-3.81-6.61l-2.68-1.56.2-.33 2.67 1.54a8.89 8.89 0 014 7v3.06a8.48 8.48 0 003.81 6.63l12.83 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M347.09 315.65L334 308.07a9.2 9.2 0 01-4.11-7.16v-3.12a8.25 8.25 0 00-3.7-6.41l-2.87-1.67.44-.76 2.88 1.67a9.16 9.16 0 014.12 7.16v3.07a8.22 8.22 0 003.7 6.42l13 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-55",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M352.22 312.46l-.23.33-12.83-7.44a8.88 8.88 0 01-4-7v-3.11a8.49 8.49 0 00-3.81-6.62l-2.64-1.56.18-.33 2.69 1.56a8.9 8.9 0 014 6.95v3.11a8.46 8.46 0 003.81 6.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M352.06 313.11l-13-7.55a9.17 9.17 0 01-4.12-7.15v-3.13a8.23 8.23 0 00-3.7-6.41l-2.83-1.68.42-.76 2.9 1.69a9.18 9.18 0 014.12 7.14v3.13a8.22 8.22 0 003.69 6.41l-.22.35 12.62 7.31.1-.14.4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-56",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M357.07 309.43L344.24 302a8.89 8.89 0 01-4-7v-3.1a8.46 8.46 0 00-3.8-6.63l-2.68-1.54.19-.35 2.69 1.56a8.91 8.91 0 014 7V295a8.48 8.48 0 003.8 6.62l12.83 7.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M357.17 309.77l-13.05-7.57A9.18 9.18 0 01340 295v-3.11a8.2 8.2 0 00-3.68-6.42l-2.89-1.66.44-.77 2.9 1.68a9.16 9.16 0 014.11 7.15V295a8.31 8.31 0 003.69 6.42l13 7.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-57",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M349.27 299.46a8.88 8.88 0 01-4-6.94v-3.12a8.46 8.46 0 00-3.79-6.62l-2.69-1.55.2-.34 2.68 1.55a8.89 8.89 0 014 7v3.14a8.49 8.49 0 003.8 6.62l12.83 7.45-.19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M362.3 307.05l-.41-.27.06-.09-12.61-7.32-.2.31a9.17 9.17 0 01-4.1-7.14v-3.14a8.24 8.24 0 00-3.69-6.41l-2.88-1.68.44-.75 2.9 1.67a9.23 9.23 0 014.11 7.16v3.15a8.22 8.22 0 003.68 6.46l13 7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-58",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M367.1 303.56l-12.81-7.45a8.88 8.88 0 01-4-7v-3.1a8.47 8.47 0 00-3.79-6.62l-2.68-1.56.19-.33 2.67 1.56a8.86 8.86 0 014 6.95v3.1a8.44 8.44 0 003.83 6.6l12.81 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M367.18 303.89l-.21-.12-12.81-7.45a9.15 9.15 0 01-4.1-7.15v-3.12a8.28 8.28 0 00-3.69-6.42l-2.88-1.63.45-.76 2.88 1.68a9.2 9.2 0 014.12 7.16v3.11a8.24 8.24 0 003.71 6.4l13 7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-59",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M355.35 287.48v-3.12a8.47 8.47 0 00-3.81-6.61l-2.68-1.56.2-.33 2.67 1.54a8.89 8.89 0 014 7v3.12a8.49 8.49 0 003.81 6.62l12.84 7.45-.2.33-12.83-7.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M372.26 302.21l-.21-.12-12.83-7.45.19-.33a8.76 8.76 0 01-3.93-6.82h-.38v-3.12a8.26 8.26 0 00-3.7-6.41l-2.87-1.67.44-.76 2.89 1.67a9.18 9.18 0 014.11 7.16v3.13a8.23 8.23 0 003.7 6.41l13 7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-60",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M377.19 298.52l-12.82-7.44a8.89 8.89 0 01-4-7V281a8.45 8.45 0 00-3.81-6.63l-2.67-1.56.18-.33 2.69 1.56a8.88 8.88 0 014 7v3.1a8.46 8.46 0 003.81 6.62l12.83 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M377.28 298.85l-13-7.55a9.19 9.19 0 01-4.11-7.16V281a8.25 8.25 0 00-3.7-6.42l-2.87-1.68.42-.76 2.9 1.69A9.17 9.17 0 01361 281v3.11a8.22 8.22 0 003.69 6.41l13 7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-61",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M369.59 288.21l12.85 7.44-.2.35-12.83-7.44a8.86 8.86 0 01-4-6.95v-3.12a8.48 8.48 0 00-3.8-6.61l-2.67-1.55.18-.35 2.68 1.56a8.91 8.91 0 014 6.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M382.34 296.34l-13-7.56a9.18 9.18 0 01-4.13-7.15v-3.14a8.24 8.24 0 00-3.68-6.4l-2.87-1.67.41-.78 2.91 1.69a9.18 9.18 0 014.11 7.15h-.39v3.11a8.64 8.64 0 003.87 6.73l.2-.34 13 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-62",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M387.29 292.65l-12.84-7.44a8.93 8.93 0 01-4-7v-3.12a8.42 8.42 0 00-3.79-6.61L364 267l.2-.33 2.68 1.55a8.91 8.91 0 014 6.95v3.12a8.44 8.44 0 003.79 6.61l12.83 7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M387.38 293l-13.06-7.56a9.25 9.25 0 01-4.11-7.16v-3.13a8.22 8.22 0 00-3.69-6.41l-2.88-1.67.44-.76L367 268a9.18 9.18 0 014.11 7.15v3.13a8.25 8.25 0 003.69 6.41l13 7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-63",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M241.61 348l-.18-.33 12.83-7.45a8.44 8.44 0 003.79-6.61v-3.12a8.91 8.91 0 014-6.95l2.68-1.56.2.33-2.69 1.56a8.44 8.44 0 00-3.79 6.62v3.16a8.91 8.91 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M241.52 348.38l-.42-.76 13-7.57a8.26 8.26 0 003.67-6.42v-3.1a9.17 9.17 0 014.1-7.15l2.91-1.69.45.75-2.9 1.68a8.24 8.24 0 00-3.68 6.42v3.16a9.21 9.21 0 01-4.11 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-64",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M236.59 344.69l-.2-.35 12.81-7.43a8.49 8.49 0 003.78-6.63v-3.1a8.93 8.93 0 014-7l2.68-1.55.19.34-2.68 1.54a8.53 8.53 0 00-3.79 6.63v3.1a8.9 8.9 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M236.49 345l-.43-.77 13-7.55a8.25 8.25 0 003.67-6.43v-3.09a9.18 9.18 0 014.14-7.16l2.91-1.69.44.77-2.9 1.67a8.28 8.28 0 00-3.66 6.42v3.09a9.17 9.17 0 01-4.1 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-65",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M231.55 342.17l-.2-.33 12.84-7.45a8.46 8.46 0 003.79-6.62v-3.12a8.94 8.94 0 014-7l2.67-1.54.2.33-2.68 1.56a8.48 8.48 0 00-3.8 6.61v3.12a8.88 8.88 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M231.46 342.5l-.44-.75 13-7.58a8.21 8.21 0 003.68-6.41v-3.11a9.2 9.2 0 014.11-7.16l2.9-1.68.44.76-2.9 1.68a8.26 8.26 0 00-3.67 6.42v3.1a9.2 9.2 0 01-4.1 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-66",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M226.51 338.81l-.19-.34 12.83-7.47a8.47 8.47 0 003.81-6.61v-3.09a8.86 8.86 0 014-6.95l2.67-1.56.2.33-2.61 1.61a8.44 8.44 0 00-3.81 6.62v3.11a8.93 8.93 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M226.42 339.14l-.43-.76 13-7.57a8.24 8.24 0 003.68-6.42v-3.09a9.17 9.17 0 014.11-7.16l2.89-1.68.44.74-2.81 1.74a8.24 8.24 0 00-3.7 6.43v3.09a9.2 9.2 0 01-4.1 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-67",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M221.48 336.29l-.2-.33 12.83-7.45a8.46 8.46 0 003.81-6.62v-3.11a8.92 8.92 0 014-7l2.68-1.55.18.33-2.67 1.56a8.49 8.49 0 00-3.81 6.62v3.11a8.85 8.85 0 01-4 6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M221.39 336.63l-.44-.76 13-7.57a8.28 8.28 0 003.69-6.42v-3.1a9.21 9.21 0 014.1-7.17l2.91-1.68.42.76-2.88 1.68a8.24 8.24 0 00-3.68 6.42v3.1a9.16 9.16 0 01-4.11 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-68",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M216.43 332.93l-.18-.33 12.83-7.45a8.44 8.44 0 003.79-6.61v-3.12a8.91 8.91 0 014-6.95l2.68-1.56.2.34-2.69 1.55a8.46 8.46 0 00-3.79 6.62v3.12a8.93 8.93 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M216.34 333.27l-.42-.76 13-7.57a8.24 8.24 0 003.68-6.42v-3.1a9.17 9.17 0 014.1-7.15l2.91-1.69.44.75-2.86 1.67a8.21 8.21 0 00-3.68 6.41v3.11a9.2 9.2 0 01-4.11 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-69",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M211.41 330.42l-.2-.33 12.79-7.45a8.44 8.44 0 003.8-6.63v-3.1a8.92 8.92 0 014-7l2.69-1.55.19.34-2.68 1.59a8.49 8.49 0 00-3.8 6.62V316a8.91 8.91 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M211.32 330.75l-.45-.75 13-7.57a8.22 8.22 0 003.67-6.43v-3.09a9.21 9.21 0 014.11-7.16l2.91-1.69.44.77-2.9 1.67a8.31 8.31 0 00-3.68 6.42V316a9.15 9.15 0 01-4.1 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-70",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M206.37 327.06l-.2-.33 12.83-7.45a8.44 8.44 0 003.79-6.62v-3.12a8.89 8.89 0 014-6.94l2.67-1.56.2.33-2.66 1.56a8.48 8.48 0 00-3.8 6.61v3.12a8.9 8.9 0 01-4 6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M206.28 327.39l-.44-.75 13-7.57a8.24 8.24 0 003.68-6.42v-3.11a9.15 9.15 0 014.11-7.15l2.9-1.69.44.76-2.9 1.68a8.26 8.26 0 00-3.67 6.42v3.1a9.2 9.2 0 01-4.1 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-71",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M196.3 321.18l-.2-.33 12.83-7.45a8.44 8.44 0 003.81-6.61v-3.12a8.93 8.93 0 014-7l2.69-1.55.18.33-2.67 1.56a8.46 8.46 0 00-3.81 6.62v3.12a8.84 8.84 0 01-4 6.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M196.21 321.52l-.44-.76 13-7.57a8.26 8.26 0 003.69-6.42v-3.1a9.19 9.19 0 014.1-7.16l2.91-1.68.42.76-2.88 1.68a8.21 8.21 0 00-3.68 6.41v3.11a9.15 9.15 0 01-4.11 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-72",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M191.26 318.67l-.19-.35 12.84-7.44a8.49 8.49 0 003.8-6.62v-3.1a8.88 8.88 0 014-7l2.68-1.55.19.33-2.68 1.55a8.48 8.48 0 00-3.79 6.63v3.1a8.93 8.93 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M191.17 319l-.44-.77 13.06-7.57a8.22 8.22 0 003.67-6.41v-3.09a9.17 9.17 0 014.1-7.16l2.92-1.69.42.76-2.9 1.68a8.23 8.23 0 00-3.68 6.42v3.09a9.18 9.18 0 01-4.11 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-73",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M186.21 315.31L186 315l12.83-7.45a8.51 8.51 0 003.8-6.63v-3.11a8.94 8.94 0 014-7l2.69-1.54.19.33-2.68 1.56a8.42 8.42 0 00-3.8 6.61v3.06a8.91 8.91 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M186.12 315.65l-.42-.76 13-7.58a8.26 8.26 0 003.67-6.42v-3.1a9.21 9.21 0 014.11-7.16l2.9-1.68.45.76-2.9 1.68a8.24 8.24 0 00-3.68 6.42v3a9.15 9.15 0 01-4.1 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-74",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M181.19 312.79l-.2-.33 12.83-7.46a8.43 8.43 0 003.8-6.62v-3.11a8.87 8.87 0 014-6.95l2.67-1.56.2.33-2.69 1.56a8.47 8.47 0 00-3.85 6.62v3.11a8.91 8.91 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M181.1 313.12l-.44-.75 13-7.57a8.24 8.24 0 003.68-6.42v-3.1a9.16 9.16 0 014.11-7.16l2.9-1.68.44.75-2.9 1.68a8.25 8.25 0 00-3.72 6.42v3.1a9.23 9.23 0 01-4.1 7.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-75",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M176.15 309.43l-.19-.34 12.83-7.44a8.48 8.48 0 003.8-6.62v-3.1a8.87 8.87 0 014-7l2.67-1.56.2.35-2.67 1.54a8.46 8.46 0 00-3.75 6.63V295a8.92 8.92 0 01-4.06 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M176.06 309.77l-.44-.77 13-7.56a8.26 8.26 0 003.67-6.42v-3.09a9.17 9.17 0 014.12-7.16l2.89-1.69.44.77-2.88 1.66a8.27 8.27 0 00-3.63 6.43V295a9.18 9.18 0 01-4.16 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-76",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M170.28 306.91l-.2-.33 12.84-7.45a8.46 8.46 0 003.81-6.59v-3.12a8.91 8.91 0 014-6.95l2.66-1.58.19.34-2.58 1.55a8.47 8.47 0 00-3.82 6.62v3.14a8.85 8.85 0 01-4 6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M170.19 307.25l-.44-.76 13.05-7.57a8.28 8.28 0 003.69-6.39v-3.11a9.18 9.18 0 014.1-7.16l2.88-1.7.45.75-2.85 1.69a8.22 8.22 0 00-3.69 6.41v3.13a9.1 9.1 0 01-4.11 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-77",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M165.24 303.56l-.19-.35 12.82-7.45a8.44 8.44 0 003.81-6.61v-3.1a8.89 8.89 0 014-7l2.68-1.55.19.33-2.68 1.56a8.46 8.46 0 00-3.81 6.62v3.1a8.86 8.86 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M165.15 303.89l-.44-.77 13-7.57a8.28 8.28 0 003.69-6.41v-3.09a9.15 9.15 0 014.1-7.16l2.92-1.69.42.76-2.84 1.68a8.21 8.21 0 00-3.69 6.42v3.09a9.16 9.16 0 01-4.11 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-78",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M160.19 301.88l-.18-.33 12.83-7.45a8.49 8.49 0 003.8-6.62v-3.12a8.94 8.94 0 014-7l2.69-1.54.19.33-2.68 1.56a8.42 8.42 0 00-3.8 6.61v3.12a8.87 8.87 0 01-4 6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M160.1 302.22l-.42-.76 13-7.58a8.22 8.22 0 003.67-6.41v-3.11a9.21 9.21 0 014.11-7.16l2.9-1.68.45.76L181 278a8.24 8.24 0 00-3.68 6.42v3.1a9.1 9.1 0 01-4.11 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-79",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M155.17 298.52l-.2-.33 12.83-7.45a8.43 8.43 0 003.8-6.62V281a8.91 8.91 0 014-7l2.69-1.56.2.33-2.69 1.59A8.48 8.48 0 00172 281v3.11a8.92 8.92 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M155.08 298.85l-.44-.75 13-7.57a8.24 8.24 0 003.68-6.42V281a9.15 9.15 0 014.1-7.16l2.91-1.69.44.75-2.9 1.71a8.26 8.26 0 00-3.67 6.43v3.09a9.22 9.22 0 01-4.1 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-80",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M150.13 296l-.19-.33 12.83-7.38a8.48 8.48 0 003.8-6.61v-3.19a8.86 8.86 0 014-6.95l2.67-1.56.2.35-2.69 1.55a8.44 8.44 0 00-3.79 6.61v3.1a8.91 8.91 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M150.05 296.34l-.45-.76 13.05-7.5a8.22 8.22 0 003.67-6.42v-3.17a9.17 9.17 0 014.12-7.16l2.89-1.68.44.77-2.89 1.67a8.24 8.24 0 00-3.68 6.41v3.09a9.14 9.14 0 01-4.1 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-81",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M145.1 292.65l-.2-.34 12.84-7.45a8.44 8.44 0 003.81-6.61v-3.12a8.89 8.89 0 014-6.95l2.68-1.55.19.33-2.67 1.56a8.44 8.44 0 00-3.81 6.61v3.12a9 9 0 01-4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M145 293l-.45-.75 13.06-7.58a8.24 8.24 0 003.69-6.41v-3.11a9.13 9.13 0 014.1-7.15l2.9-1.69.44.75-2.89 1.69a8.21 8.21 0 00-3.68 6.41v3.11a9.23 9.23 0 01-4.11 7.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-82",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-4",
    d: "M201 324.13l-.2-.34 12.84-7.45a8.42 8.42 0 003.79-6.61v-3.12a8.91 8.91 0 014-6.95l2.67-1.55.2.33-2.71 1.56a8.48 8.48 0 00-3.8 6.61v3.12a8.9 8.9 0 01-4 6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M200.88 324.46l-.44-.75 13-7.58a8.21 8.21 0 003.68-6.41v-3.11a9.15 9.15 0 014.11-7.15l2.9-1.69.44.76-2.9 1.68a8.26 8.26 0 00-3.67 6.41v3.11a9.2 9.2 0 01-4.1 7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-83",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-3",
    d: "M266.61 323.7l-99.89-57.92 99.89-57.91 99.88 57.92-99.88 57.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-5",
    d: "M265.86 323.54l-97.39-56.48a1.47 1.47 0 010-2.56l97.39-56.5a1.47 1.47 0 011.49 0l97.4 56.48a1.49 1.49 0 010 2.57l-97.4 56.46a1.47 1.47 0 01-1.49.03zM366 265.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M266.61 324.11a1.8 1.8 0 01-.93-.25l-97.4-56.48a1.85 1.85 0 010-3.2l97.4-56.47a1.87 1.87 0 011.86 0l97.39 56.48a1.85 1.85 0 010 3.2l-97.39 56.47a1.83 1.83 0 01-.93.25zm0-115.91a1.09 1.09 0 00-.56.15l-97.4 56.46a1.13 1.13 0 000 1.94l97.4 56.48a1.12 1.12 0 001.12 0l97.39-56.47a1.11 1.11 0 000-1.93l-97.39-56.48a1.15 1.15 0 00-.56-.15z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-84",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M266.6 315.17l-86.33-49.82 86.33-49.81 86.35 49.81-86.35 49.82z"
  })), /*#__PURE__*/React.createElement("image", {
    id: "opensource-hero_svg__Bitmap",
    width: 157,
    height: 96,
    transform: "matrix(1.21 0 0 1.21 172.6 205.56)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      isolation: "isolate"
    },
    opacity: 0.3
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-85",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M266.6 313.5l-86.33-49.81 86.33-49.82 86.35 49.82-86.35 49.81z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-86",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M266.6 283.59l-34.49-19.9 34.49-19.91 34.5 19.91-34.5 19.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__open-source"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__hero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__hero-img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opensource-hero_svg__Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M428 262.1a10.74 10.74 0 01-5.33-1.42l-102.59-59.17a3.36 3.36 0 010-5.8l64.22-37.06a1 1 0 01.95 0l107.38 62a3.37 3.37 0 010 5.81l-59.36 34.25a10.77 10.77 0 01-5.27 1.39zm-43.21-102.84a.33.33 0 00-.14 0l-64.2 37a2.62 2.62 0 000 4.52L423 260a9.9 9.9 0 009.91 0l59.36-34.25a2.63 2.63 0 000-4.54l-107.36-62a.2.2 0 00-.12.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-87",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M312.56 179.41l6.24 3.24 62.47-36.05a4.55 4.55 0 014.08.17l107.82 62.17c1-.56 5.73-2.83 5.73-2.83l-2.28 5.94a1.39 1.39 0 01-.64.71l-65.81 38a4.53 4.53 0 01-4.07-.17L315.77 187a2 2 0 01-.93-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-88",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M313.53 180.42l113 65.21a4.72 4.72 0 004.19.18l67.43-38.92c1.07-.61.94-1.7-.3-2.41l-113-65.21a4.67 4.67 0 00-4.17-.17L313.22 178c-1.07.63-.93 1.75.31 2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-89",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M313.53 179.75l113 65.22a4.72 4.72 0 004.19.18l67.43-38.87a1.33 1.33 0 00.65-.73 1.11 1.11 0 01-.65 1.38l-67.43 38.92a4.69 4.69 0 01-4.19-.19l-113-65.24c-.84-.47-1.21-1.12-1-1.68a1.86 1.86 0 001 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-90",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M460.13 215.74l-93.91-54.25a2 2 0 00-2 0l-33.45 19.29a.72.72 0 00-.32.6.75.75 0 00.32.61l93.86 54.15a2 2 0 002 0l33.49-19.29a.77.77 0 00.27-.55.74.74 0 00-.26-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-91",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M346.99 174.92l90.08 51.99 3.64-2.1-90.09-51.99-3.63 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-92",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M424.89 213.19l18.02 10.4 3.63-2.1-18.15-10.46-3.5 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-93",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M448.17 216.37l3.63 2.08 3.64-2.08-3.64-2.1-3.63 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-94",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M460.13 217l-.33.2-93.58-54a2 2 0 00-2 0l-33.11 19.14-.33-.19a.72.72 0 010-1.2l33.45-19.29a2 2 0 012 0l93.91 54.25a.67.67 0 01.24.54.69.69 0 01-.25.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-95",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M361.68 166.44l86.49 49.93 4.3-1.72-87.17-50.29-3.62 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-96",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M352.78 171.58l76.51 44.15 3.64-2.1-76.52-44.15-3.63 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-97",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M341.2 178.26l90.08 51.99 3.64-2.1-90.09-51.98-3.63 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-98",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M335.41 181.6l90.08 51.98 3.64-2.08-90.09-51.99-3.63 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-99",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M312.74 177.73L327 93l-1.2-.48 1.72-1a1.23 1.23 0 011.33.1l114.18 65.87a3.26 3.26 0 011.48 2.91l-14.4 85.38a1.11 1.11 0 01-.61.87l-1.69 1-.29-1.58h.1l-113.4-65.45a3.24 3.24 0 01-1.48-2.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-100",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M426.7 191.45l-25.33-14.6a1.1 1.1 0 01-.74-1 1.09 1.09 0 01.74-1l17.31-10a4 4 0 013.62 0l25.33 14.61a1.1 1.1 0 010 2.08l-17.31 10a3.92 3.92 0 01-3.62-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-101",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M312.44 181.65l114.16 65.88c.88.51 1.64.21 1.8-.7l14.39-85.38a3.16 3.16 0 00-1.48-2.89L327.14 92.68c-.88-.51-1.64-.22-1.79.69L311 178.75a3.22 3.22 0 001.44 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-102",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M460.6 231.52v-1.2c0-.11-.07-.17-.16-.12l-4.38 2.53a.36.36 0 00-.15.3v1.21c0 .1.07.16.15.12l4.38-2.54a.37.37 0 00.16-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-103",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M454.08 235.3v-1.21c0-.11-.07-.17-.15-.12l-4.37 2.53a.35.35 0 00-.17.3v1.2c0 .11.07.17.17.12l4.37-2.53a.38.38 0 00.15-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-104",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M442.5 159.84l1.88-.82a2.56 2.56 0 01.25 1.41l-14.41 85.38a1.08 1.08 0 01-.6.87l-1.69 1-.29-1.58h.1l-5.74-3.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-105",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M144.94 285.61a4.65 4.65 0 01-2.28-.7l-14.6-8.44a.59.59 0 01-.22-.81.6.6 0 01.81-.22l14.61 8.44a2.13 2.13 0 003.54-2.05v-3.56a3.28 3.28 0 015.33-3.08l3.06 1.76a.61.61 0 01-.61 1l-3.05-1.76a2.12 2.12 0 00-3.53 2v3.61a3.63 3.63 0 01-1.61 3.39 2.8 2.8 0 01-1.45.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-106",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M179.18 339.75a.59.59 0 01-.59-.43.6.6 0 01.29-.68l14.61-8.44a9.13 9.13 0 004.13-7.21v-3.52a10.35 10.35 0 014.73-8.2l3.05-1.76a.61.61 0 01.6 0 .58.58 0 01.29.51.6.6 0 01-.29.51l-3 1.76a9.11 9.11 0 00-4.15 7.23v3.52a10.3 10.3 0 01-4.73 8.19l-14.61 8.44a.73.73 0 01-.29.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-107",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M173.5 336.42a.58.58 0 01-.59-.43.6.6 0 01.29-.68l14.6-8.43a9.16 9.16 0 004.15-7.24v-3.52a10.35 10.35 0 014.73-8.2l3-1.76a.61.61 0 01.6 0 .58.58 0 01.3.52.61.61 0 01-.3.51l-3 1.76a9.13 9.13 0 00-4.15 7.16v3.52a10.34 10.34 0 01-4.73 8.2l-14.61 8.44a.49.49 0 01-.29.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-108",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M167.82 333.14a.57.57 0 01-.52-.28.61.61 0 01.21-.82l14.61-8.44a9.14 9.14 0 004.15-7.17v-3.52a10.32 10.32 0 014.73-8.19l3.05-1.76a.59.59 0 11.59 1l-3 1.77a9.17 9.17 0 00-4.15 7.18v3.52a10.29 10.29 0 01-4.73 8.19l-14.6 8.44a.51.51 0 01-.29.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-109",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M162.13 329.88a.6.6 0 01-.3-1.11l14.61-8.44a9.15 9.15 0 004.15-7.23v-3.49a10.34 10.34 0 014.73-8.2l3.05-1.76a.62.62 0 01.82.22.61.61 0 01-.23.82l-3 1.76a9.16 9.16 0 00-4.15 7.16v3.62a10.3 10.3 0 01-4.73 8.2l-14.6 8.44a.65.65 0 01-.31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-110",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M156.45 326.61a.6.6 0 01-.3-1.12l14.61-8.44a9.13 9.13 0 004.15-7.16v-3.52a10.34 10.34 0 014.73-8.2l3.05-1.76a.57.57 0 01.59 0 .61.61 0 01.3.51.59.59 0 01-.3.51l-3 1.78a9.12 9.12 0 00-4.15 7.16v3.52a10.32 10.32 0 01-4.73 8.2l-14.61 8.44a.61.61 0 01-.3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-111",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M150.77 323.33a.59.59 0 01-.59-.43.6.6 0 01.29-.68l14.61-8.44a9.14 9.14 0 004.15-7.17v-3.51a10.27 10.27 0 014.73-8.18l3-1.77a.6.6 0 01.89.52.61.61 0 01-.3.51l-3 1.76a9.13 9.13 0 00-4.15 7.16v3.52a10.31 10.31 0 01-4.73 8.2l-14.61 8.44a.6.6 0 01-.3.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-112",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M145.09 320.06a.59.59 0 01-.3-1.11l14.61-8.43a9.2 9.2 0 004.15-7.18v-3.52a10.31 10.31 0 014.72-8.2l3.06-1.76a.6.6 0 11.59 1l-3 1.83a9.13 9.13 0 00-4.15 7.16v3.52a10.32 10.32 0 01-4.73 8.2l-14.61 8.44a.51.51 0 01-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-113",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M139.41 316.84a.58.58 0 01-.52-.28.61.61 0 01.22-.82l14.6-8.44a9.14 9.14 0 004.11-7.21v-3.52a10.28 10.28 0 014.72-8.2l3.06-1.76a.57.57 0 01.59 0 .59.59 0 010 1l-3 1.76a9.16 9.16 0 00-4.15 7.24v3.52a10.35 10.35 0 01-4.73 8.2l-14.61 8.43a.54.54 0 01-.25.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-114",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M133.69 313.52a.65.65 0 01-.52-.3.6.6 0 01.22-.81L148 304a9.21 9.21 0 004.15-7.23v-3.52a10.28 10.28 0 014.72-8.2l3.06-1.76a.61.61 0 01.82.21.62.62 0 01-.23.82l-3 1.76a9.14 9.14 0 00-4.15 7.17v3.52a10.32 10.32 0 01-4.73 8.19L134 313.37a.57.57 0 01-.3.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-115",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M128 310.25a.59.59 0 01-.57-.45.6.6 0 01.27-.67l14.61-8.44a9.13 9.13 0 004.15-7.16V290a10.34 10.34 0 014.73-8.2l3.05-1.76a.57.57 0 01.59 0 .58.58 0 01.3.51.57.57 0 01-.3.51l-3.09 1.78a9.2 9.2 0 00-4.15 7.17v3.52a10.3 10.3 0 01-4.72 8.2l-14.61 8.44a.77.77 0 01-.26.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-116",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-11",
    d: "M360 341.56L385.3 327a1.08 1.08 0 000-2.06l-17.31-10a4 4 0 00-3.62 0L339 329.5a1.1 1.1 0 000 2.08l17.31 10a3.92 3.92 0 003.69-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-117",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M339.07 330.35l25.34-14.61a4 4 0 013.62 0l17.31 10a1.52 1.52 0 01.62.61c.26-.5.06-1.06-.62-1.45l-17.31-10a4 4 0 00-3.62 0l-25.34 14.6c-.68.4-.89 1-.62 1.46a1.52 1.52 0 01.62-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-118",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M359.11 341.45l25.33-14.6a1.09 1.09 0 000-2.07l-17.31-10a4 4 0 00-3.62 0l-25.33 14.61a1.1 1.1 0 000 2.08l17.32 10a3.93 3.93 0 003.61 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-119",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-12",
    d: "M338.21 330.24l25.33-14.61a4 4 0 013.62 0l17.31 10a1.63 1.63 0 01.63.62c.25-.51.06-1.06-.63-1.46l-17.31-10a4 4 0 00-3.62 0l-25.33 14.61c-.68.4-.88 1-.62 1.46a1.52 1.52 0 01.62-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-120",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-12",
    d: "M193.06 331.79l-25.33-14.61a4 4 0 00-3.62 0l-17.31 10a1.61 1.61 0 00-.63.61c-.26-.5 0-1.06.63-1.46l17.31-10a4 4 0 013.62 0L193.06 331c.69.4.9 1 .63 1.46a1.63 1.63 0 00-.63-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-121",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-13",
    d: "M213.5 177.12l-6.27 3.25-62.47-36a4.52 4.52 0 00-4.08.17L33 206.66c-1-.58-5.73-2.84-5.73-2.84l2.28 6a1.34 1.34 0 00.64.71l65.79 38a4.49 4.49 0 004.07-.17l110.27-63.63a1.91 1.91 0 00.93-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-122",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-14",
    d: "M212.54 178.14l-113 65.21a4.6 4.6 0 01-4.18.17l-67.44-38.9c-1.07-.62-.94-1.7.31-2.41l113-65.21a4.63 4.63 0 014.18-.17l67.44 38.9c1.05.63.92 1.7-.31 2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-123",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M212.54 177.49l-113 65.21a4.6 4.6 0 01-4.18.17L27.91 204a1.45 1.45 0 01-.66-.74 1.21 1.21 0 00.66 1.39l67.44 38.9a4.6 4.6 0 004.18-.17l113-65.21c.83-.47 1.2-1.12 1-1.67a2 2 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-124",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-11",
    d: "M65.44 229.25V228c0-.11.07-.17.16-.12l4.4 2.57a.35.35 0 01.16.31V232c0 .11-.07.17-.16.12l-4.37-2.53a.37.37 0 01-.16-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-125",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-11",
    d: "M72 233v-1.2c0-.12.07-.17.16-.12l4.36 2.52a.36.36 0 01.17.31v1.21c0 .12-.07.18-.17.12l-4.38-2.54a.37.37 0 01-.14-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-126",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-14",
    d: "M65.94 213.47l93.91-54.25a2 2 0 012 0l33.44 19.29a.69.69 0 01.33.6.7.7 0 01-.33.6L101.44 234a2 2 0 01-2 0l-33.5-19.27a.7.7 0 010-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-127",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M65.94 214.71l.32.19 93.59-54a2 2 0 012 0L195 180.05l.33-.19a.72.72 0 000-1.21l-33.44-19.29a2 2 0 00-2 0l-93.95 54.25a.71.71 0 000 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-128",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M164.38 164.17l-86.5 49.91-4.28-1.71 87.16-50.28 3.62 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-129",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M173.28 169.31l-76.51 44.15-3.63-2.1 76.51-44.15 3.63 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-130",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M179.08 172.65l-90.09 51.98-3.63-2.1 90.08-51.98 3.64 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-131",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M184.87 175.99l-90.09 51.98-3.63-2.1 90.09-51.97 3.63 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-132",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M190.66 179.33l-90.09 51.98-3.63-2.1 90.09-51.97 3.63 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-133",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M77.88 214.08l-3.62 2.1-3.63-2.1 3.63-2.08 3.62 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-134",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M101.16 210.91L83.15 221.3l-3.63-2.08 18.15-10.48 3.49 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-135",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-11",
    d: "M213.32 175.46L199 90.75l1.2-.48-1.72-1a1.22 1.22 0 00-1.33.09L83 155.25a3.23 3.23 0 00-1.48 2.91l14.4 85.36a1.07 1.07 0 00.6.88l1.69 1 .29-1.57h-.09l113.47-65.48a3.2 3.2 0 001.46-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-136",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-13",
    d: "M83.6 157.56l-1.82-.82a2.58 2.58 0 00-.25 1.42l14.41 85.36a1.07 1.07 0 00.6.88l1.69 1 .29-1.57h-.1l5.74-3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-137",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-15",
    d: "M213.62 179.37L99.46 245.24c-.88.51-1.64.21-1.8-.69l-14.39-85.38a3.23 3.23 0 011.48-2.91l114.17-65.87c.88-.51 1.64-.22 1.8.7l14.39 85.43a3.18 3.18 0 01-1.49 2.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M97.25 259.73a10.75 10.75 0 01-5.34-1.42l-59.35-34.25a3.34 3.34 0 010-5.8l107.36-62a1 1 0 01.94 0l.51.3 63.72 36.77a3.35 3.35 0 010 5.8l-102.54 59.18a10.81 10.81 0 01-5.3 1.42zm43.15-102.84a.22.22 0 00-.13 0l-107.35 62a2.61 2.61 0 000 4.52l59.35 34.25a10.14 10.14 0 005 1.33 10 10 0 004.93-1.33l102.52-59.16a2.6 2.6 0 000-4.52l-64.21-37.06a.2.2 0 00-.11-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-138",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M212.63 177l-6.22 3.25-62.47-36.05a4.52 4.52 0 00-4.08.17L32.1 206.56c-1-.57-5.73-2.83-5.73-2.83l2.33 5.94a1.26 1.26 0 00.63.71l65.71 38a4.48 4.48 0 004.08-.17l110.27-63.61a2.12 2.12 0 00.93-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-139",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M211.68 178.05l-113 65.2a4.67 4.67 0 01-4.17.18l-67.46-38.92c-1.07-.61-.93-1.7.3-2.41l113-65.21a4.62 4.62 0 014.13-.16l67.44 38.91c1.08.61.99 1.68-.24 2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-140",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M211.68 177.4l-113 65.19a4.64 4.64 0 01-4.17.19l-67.46-38.92a1.45 1.45 0 01-.66-.72 1.14 1.14 0 00.66 1.37l67.44 38.92a4.67 4.67 0 004.17-.18l113-65.2c.83-.48 1.15-1.14.95-1.69a2 2 0 01-.95 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-141",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M64.59 229.14v-1.21c0-.12.07-.18.15-.12l4.37 2.52a.41.41 0 01.16.31v1.2c0 .11-.08.17-.16.12l-4.37-2.52a.38.38 0 01-.15-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-142",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M71.11 232.91v-1.2c0-.11.07-.17.17-.12l4.37 2.53a.38.38 0 01.15.3v1.21c0 .11-.07.17-.15.12l-4.37-2.57a.38.38 0 01-.17-.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-143",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M65.07 213.36L159 159.17a2 2 0 012 0l33.43 19.29a.71.71 0 010 1.2l-93.86 54.16a2 2 0 01-2 0l-33.5-19.29a.71.71 0 010-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-144",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M65.07 214.6l.34.19L159 160.84a2 2 0 012 0L194.11 180l.33-.19a.72.72 0 00.33-.61.7.7 0 00-.33-.6L161 159.3a2 2 0 00-2 0l-93.93 54.19a.72.72 0 00-.27.56.7.7 0 00.27.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-145",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M163.53 164.06l-86.51 49.91-4.28-1.7 87.16-50.29 3.63 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-146",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M172.42 169.2L95.9 213.35l-3.62-2.1 76.52-44.15 3.62 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-147",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M178.21 172.54l-90.09 51.98-3.62-2.09 90.09-51.98 3.62 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-148",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M184.01 175.88l-90.09 51.98-3.63-2.1 90.09-51.97 3.63 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-149",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M189.8 179.23L99.71 231.2l-3.63-2.08 90.09-51.99 3.63 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-150",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M77.02 213.97l-3.62 2.1-3.63-2.1 3.63-2.08 3.62 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-151",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M100.3 210.8l-18.01 10.41-3.63-2.1 18.15-10.46 3.49 2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-152",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M212.45 175.31l-14.28-84.7 1.15-.49-1.73-1a1.27 1.27 0 00-1.34.09l-114.16 65.9a3.18 3.18 0 00-1.48 2.9L95 243.43a1.08 1.08 0 00.61.86l1.69 1 .29-1.58h-.1L211 178.22a3.21 3.21 0 001.43-2.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-153",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M82.74 157.47l-1.88-.83a2.52 2.52 0 00-.24 1.41L95 243.43a1.08 1.08 0 00.61.86l1.69 1 .29-1.58h-.1l5.74-3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-154",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M212.77 179.27L98.66 245.15c-.88.51-1.64.21-1.79-.7l-14.41-85.38a3.24 3.24 0 011.54-2.89l114.12-65.89c.88-.5 1.63-.21 1.79.7l14.4 85.38a3.21 3.21 0 01-1.54 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-155",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-11",
    d: "M465.65 325.4l-14.53-86.2 1.2-.5-1.8-1a1.21 1.21 0 00-1.35.09L333 304.85a3.27 3.27 0 00-1.46 2.95l14.66 86.88a1.1 1.1 0 00.62.9l1.71 1 .29-1.6h-.1l115.49-66.63a3.3 3.3 0 001.44-2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-156",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-13",
    d: "M333.63 307.21l-1.9-.82a2.62 2.62 0 00-.21 1.41l14.66 86.88a1.1 1.1 0 00.62.9l1.71 1 .29-1.6h-.1l5.85-3.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-157",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M466 329.4l-116.2 67c-.89.52-1.66.22-1.82-.71L333.3 308.8a3.3 3.3 0 011.5-3l116.15-67c.9-.52 1.66-.21 1.82.71l14.7 86.87a3.29 3.29 0 01-1.47 3.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-158",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-15",
    d: "M449.48 244.39l-112 64.64 13.89 81.82 111.92-64.58-13.81-81.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-159",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-13",
    d: "M539 370.54l-6.35 3.36L469 337.15a4.63 4.63 0 00-4.15.18L355.24 400.6c-1.05-.59-5.84-2.88-5.84-2.88l2.32 6a1.35 1.35 0 00.65.72l67 38.58a4.63 4.63 0 004.15-.17l112.19-64.75a2.07 2.07 0 00.94-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-160",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-14",
    d: "M538 371.57l-115 66.37a4.75 4.75 0 01-4.25.17l-68.62-39.59c-1.1-.64-1-1.74.3-2.41l115-66.31a4.67 4.67 0 014.24-.18l68.64 39.46c1.11.67.97 1.77-.31 2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-161",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-14",
    d: "M368 394.8l95.56-55.14a2.05 2.05 0 012.06 0l34 19.68a.71.71 0 010 1.2l-95.53 55.12a2 2 0 01-2 0L368 396.07a.72.72 0 010-1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-162",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M368 396.07l.33.2 95.23-54.92a2 2 0 012.06 0l33.69 19.48.34-.2a.76.76 0 00.35-.63.73.73 0 00-.33-.6l-34-19.76a2.05 2.05 0 00-2.06 0L368 394.8a.72.72 0 000 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-163",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M468.22 344.64l-83.02 47.91-3.69-2.13 83.02-47.9 3.69 2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-164",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M477.27 349.86l-77.87 44.93-3.69-2.13 77.87-44.92 3.69 2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-165",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M483.17 353.27l-91.68 52.89-3.69-2.12 91.68-52.9 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-166",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M489.05 356.67l-91.67 52.9-3.7-2.13 91.68-52.9 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-167",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M494.95 360.07l-91.68 52.9-3.69-2.13 91.68-52.9 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-168",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-11",
    d: "M467.28 408.15l25.77-14.87a1.12 1.12 0 00.74-1 1.14 1.14 0 00-.74-1.06L475.42 381a4 4 0 00-3.62 0L446 395.88a1.1 1.1 0 000 2.09l17.63 10.18a4 4 0 003.65 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-169",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M446 396.73l25.78-14.86a4 4 0 013.62 0L493.05 392a1.57 1.57 0 01.62.63c.27-.51.06-1.09-.62-1.48L475.42 381a4 4 0 00-3.62 0L446 395.88c-.69.39-.89 1-.63 1.48a1.73 1.73 0 01.63-.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-170",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M379.65 359.65l9.06-5.23.27 1.56-9.06 5.25-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-171",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.17 353.58l4.94-2.85.26 1.58-4.93 2.84-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-172",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M402.79 346.3l3.57-2.07.27 1.58-3.57 2.06-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-173",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M400.19 347.81l1.21-.71.27 1.57-1.22.71-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-174",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M396.58 349.88l2.22-1.27.26 1.56-2.2 1.29-.28-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-175",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.82 347.63l3.57-2.06.27 1.56-3.57 2.07-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-176",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M378.44 352.46l6.99-4.03.28 1.56-7.01 4.05-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-177",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M388.47 326.98l7-4.04.27 1.57-7 4.05-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-178",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M384.88 329.06l2.21-1.27.26 1.56-2.21 1.28-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-179",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M389.64 334.18l7-4.04.26 1.56-6.99 4.05-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-180",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.04 336.26l2.22-1.29.26 1.58-2.22 1.28-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-181",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M383.31 295.93l-13.18 7.62-.27-1.56 13.18-7.62.27 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-182",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M387.95 293.26l-3.25 1.88-.27-1.57 3.26-1.89.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-183",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M411.13 291.73l-13.19 7.62-.26-1.58 13.18-7.62.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-184",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M415.77 289.04l-3.26 1.89-.26-1.58 3.26-1.88.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-185",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M374.3 305.08l-3.57 2.06-.27-1.56 3.57-2.08.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-186",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M396.04 300.42l-3.57 2.07-.27-1.58 3.57-2.06.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-187",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M382.68 300.24l-6.99 4.05-.27-1.58 7-4.04.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-188",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.29 298.16l-2.22 1.28-.27-1.58 2.22-1.28.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-189",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M394.73 293.28l-6.99 4.05-.27-1.58 7-4.04.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-190",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M398.34 291.21l-2.22 1.28-.26-1.57 2.21-1.28.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-191",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M395.43 296.82l-3.57 2.07-.28-1.57 3.59-2.06.26 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-192",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M403.82 291.99l-7.01 4.04-.27-1.58 7-4.04.28 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-193",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M407.41 289.9l-2.22 1.28-.26-1.56 2.22-1.28.26 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-194",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M378.64 306.52l-7.31 4.22-.26-1.58 7.31-4.22.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-195",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.31 302.66l-5.28 3.05-.27-1.57 5.29-3.05.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-196",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.27 299.8l-3.57 2.07-.27-1.58 3.57-2.07.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-197",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M424.92 283.77l-7.31 4.23-.27-1.58 7.31-4.22.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-198",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M431.59 279.92l-5.29 3.05-.26-1.56 5.28-3.07.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-199",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M436.54 277.05l-3.57 2.07-.26-1.57 3.57-2.06.26 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-200",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M422.07 331.23l7.3-4.22.26 1.58-7.3 4.22-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-201",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M415.4 335.09l5.28-3.05.27 1.57-5.29 3.05-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-202",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M410.44 337.95l3.57-2.06.27 1.58-3.58 2.06-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-203",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M419.63 336.6l7.31-4.22.27 1.56-7.31 4.23-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-204",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M412.96 340.44l5.3-3.05.26 1.58-5.29 3.05-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-205",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M408.01 343.31l3.58-2.06.26 1.57-3.57 2.06-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-206",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.13 329.95l2.47-1.43.25 1.58-2.46 1.42-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-207",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.48 332.63l3.26-1.88.26 1.58-3.25 1.88-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-208",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M379.31 310.09l-7.31 4.22-.27-1.57 7.31-4.23.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-209",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.98 306.23l-5.3 3.06-.26-1.58 5.29-3.05.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-210",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.92 303.37l-3.57 2.06-.26-1.56 3.57-2.08.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-211",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M375.07 316.48l-2.47 1.42-.27-1.57 2.48-1.43.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-212",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M379.71 313.79l-3.26 1.88-.27-1.57 3.27-1.88.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-213",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.35 309.95l-5.25 3.04-.26-1.58 5.24-3.02.27 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-214",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M393.48 339.85l2.47-1.42.27 1.58-2.48 1.42-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-215",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M388.83 342.54l3.27-1.88.27 1.57-3.27 1.88-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-216",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M382.2 346.38l5.25-3.04.26 1.58-5.25 3.02-.26-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-217",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M397.24 334.03l5.26-3.04.27 1.57-5.26 3.04-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-218",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M388.64 338.71l7.1-4.09.26 1.57-7.09 4.08-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-219",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.05 340.79l2.2-1.29.28 1.58-2.22 1.28-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-220",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M381.58 342.78l2.22-1.28.27 1.57-2.22 1.29-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-221",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M382.07 322.49l6.99-4.05.27 1.58-7 4.04-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-222",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M378.46 324.57l2.22-1.28.26 1.57-2.21 1.28-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-223",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M382.55 318.26l2.46-1.42.27 1.56-2.47 1.44-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-224",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M391.26 321.14l2.47-1.42.27 1.57-2.48 1.42-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-225",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M394.78 319.12l5.92-3.43.27 1.57-5.92 3.42-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-226",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M401.75 315.09l3.53-2.04.26 1.57-3.52 2.04-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-227",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M377.89 320.95l3.27-1.88.27 1.57-3.27 1.88-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-228",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M377.59 317.26l2.46-1.44.27 1.58-2.46 1.43-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-229",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M372.95 319.94l3.25-1.88.27 1.57-3.26 1.89-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-230",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M387.68 323.2l2.22-1.27.26 1.57-2.22 1.28-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-231",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M384.23 325.2l2.2-1.27.27 1.56-2.21 1.28-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-232",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M401.25 343.25l7.56-4.36.27 1.58-7.57 4.36-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-233",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M392.78 348.15l7.08-4.09.27 1.57-7.08 4.1-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-234",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M389.18 350.23l2.21-1.28.27 1.57-2.21 1.28-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-235",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.72 352.22l2.22-1.28.27 1.58-2.22 1.28-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-236",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M383.83 353.32l-4.78 2.76.27 1.58 4.77-2.77-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M421.44 454.41A11 11 0 01416 453l-60.4-34.86a3.39 3.39 0 010-5.87l109.3-63.09a1 1 0 011 0l.51.29 64.84 37.37a3.4 3.4 0 010 5.88l-104.39 60.21a10.84 10.84 0 01-5.42 1.48zm43.95-104.63a.28.28 0 00-.12 0L356 412.88a2.66 2.66 0 000 4.6l60.4 34.85a10 10 0 0010.11 0l104.36-60.2a2.67 2.67 0 000-4.61l-65.34-37.66a.28.28 0 00-.14-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-237",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M465.52 325.13L451 238.93l1.2-.49-1.76-1a1.29 1.29 0 00-1.36.09l-116.23 67.05a3.33 3.33 0 00-1.51 3L346 394.39a1.11 1.11 0 00.61.9l1.72 1 .3-1.6h-.1L464 328.09a3.26 3.26 0 001.52-2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-238",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M333.5 306.93l-1.9-.85a2.69 2.69 0 00-.26 1.45L346 394.39a1.11 1.11 0 00.61.9l1.72 1 .3-1.6h-.1l5.84-3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-239",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M465.83 329.12l-116.21 67.05c-.89.51-1.67.21-1.82-.72l-14.62-86.88a3.22 3.22 0 011.5-2.94l116.18-67c.91-.52 1.67-.23 1.82.7l14.66 86.89a3.28 3.28 0 01-1.51 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-240",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M449.36 244.13l-112.01 64.62 13.88 81.82L463.17 326l-13.81-81.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-241",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M538.87 370.28l-6.34 3.32L469 336.89a4.57 4.57 0 00-4.15.17l-109.71 63.27c-1.05-.58-5.84-2.89-5.84-2.89l2.33 6a1.37 1.37 0 00.65.71l67 38.64a4.57 4.57 0 004.15-.17l112.15-64.72a2 2 0 00.94-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-242",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M537.89 371.31l-115 66.3a4.74 4.74 0 01-4.26.18L350 398.24c-1.09-.63-.95-1.72.31-2.41l115-66.31a4.77 4.77 0 014.26-.18l68.63 39.6c1.08.53.95 1.63-.31 2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg___Path_",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M537.89 370.64l-115 66.36a4.74 4.74 0 01-4.26.18L350 397.58a1.43 1.43 0 01-.66-.75 1.22 1.22 0 00.66 1.41l68.63 39.55a4.74 4.74 0 004.26-.18l115-66.3c.85-.5 1.2-1.15 1-1.73a2 2 0 01-1 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-243",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M367.89 394.53l95.58-55.15a2.08 2.08 0 012 0l34 19.68a.75.75 0 01.36.64.76.76 0 01-.36.64L404 415.46a2.1 2.1 0 01-2.06 0l-34.05-19.66a.73.73 0 010-1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-244",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-12",
    d: "M367.89 395.8l.34.2 95.24-54.95a2.08 2.08 0 012 0l33.68 19.48.35-.19a.76.76 0 00.36-.64.75.75 0 00-.36-.64l-34-19.68a2.08 2.08 0 00-2 0l-95.58 55.15a.74.74 0 000 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-245",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M468.09 344.37l-83.02 47.9-3.69-2.13 83.02-47.9 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-246",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M477.15 349.59l-77.87 44.92-3.69-2.12 77.87-44.93 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-247",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M483.04 352.99l-91.68 52.9-3.69-2.13 91.67-52.9 3.7 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-248",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M488.93 356.39l-91.68 52.91-3.69-2.14 91.68-52.9 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-249",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M494.82 359.79l-91.68 52.9-3.69-2.13 91.68-52.9 3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-250",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M380.05 395.17l-3.68 2.13-3.69-2.13 3.68-2.14 3.69 2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-251",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M393.08 398.1l-7.66 4.42-3.69-2.14 7.66-4.42 3.69 2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-252",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M467.15 407.87L492.91 393a1.12 1.12 0 000-2.11l-17.62-10.17a4 4 0 00-3.62 0l-25.79 14.88a1.1 1.1 0 00-.77 1 1.12 1.12 0 00.77 1.06l17.61 10.16a4.07 4.07 0 003.66 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-253",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-12",
    d: "M445.88 396.47l25.77-14.88a4 4 0 013.62 0l17.62 10.18a1.43 1.43 0 01.63.61c.27-.51.07-1.07-.63-1.48l-17.62-10.17a4 4 0 00-3.62 0l-25.77 14.87c-.7.41-.9 1-.64 1.48a1.57 1.57 0 01.64-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-254",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M379.52 359.37l9.06-5.23.27 1.58-9.06 5.23-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-255",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.04 353.31l4.94-2.85.26 1.57-4.93 2.84-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-256",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M402.66 346.02l3.57-2.06.27 1.57-3.58 2.06-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-257",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M400.05 347.53l1.22-.71.28 1.58-1.23.7-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-258",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M396.46 349.61l2.22-1.28.26 1.56-2.22 1.3-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-259",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.69 347.35l3.58-2.06.27 1.57-3.59 2.06-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-260",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M378.3 352.2l7.01-4.05.27 1.58-7.01 4.03-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-261",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M388.34 326.71l7.01-4.05.26 1.58-7 4.04-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-262",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M384.75 328.79l2.21-1.28.27 1.56-2.22 1.3-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-263",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M389.51 333.9l7-4.04.26 1.58-6.99 4.04-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-264",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.92 335.98l2.2-1.28.27 1.57-2.21 1.28-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-265",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M383.18 295.67l-13.19 7.6-.26-1.56 13.18-7.62.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-266",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M387.82 292.98l-3.26 1.88-.26-1.57 3.26-1.88.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-267",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M410.99 291.45l-13.18 7.62-.27-1.57 13.19-7.62.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-268",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M415.64 288.77l-3.26 1.88-.26-1.56 3.25-1.9.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-269",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M374.18 304.81l-3.58 2.06-.27-1.57 3.58-2.06.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-270",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M395.9 300.15l-3.57 2.06-.26-1.58 3.57-2.06.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-271",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M382.56 299.96l-7.01 4.05-.26-1.58 6.99-4.04.28 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-272",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.16 297.89l-2.22 1.27-.27-1.56 2.22-1.28.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-273",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M394.6 293.02l-7 4.03-.26-1.56 6.99-4.05.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-274",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M398.21 290.93l-2.22 1.28-.27-1.57 2.22-1.28.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-275",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M395.3 296.55l-3.57 2.07-.27-1.58 3.58-2.06.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-276",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M403.68 291.71l-6.99 4.04-.27-1.56 7-4.06.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-277",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M407.28 289.63l-2.21 1.29-.26-1.58 2.2-1.28.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-278",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M378.52 306.24l-7.31 4.22-.27-1.57 7.31-4.22.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-279",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.18 302.38l-5.28 3.06-.27-1.57 5.3-3.05.25 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-280",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.14 299.53l-3.57 2.06-.27-1.57 3.57-2.06.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-281",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M424.78 283.5l-7.31 4.22-.26-1.56 7.31-4.24.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-282",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M431.45 279.65l-5.28 3.05-.27-1.57 5.29-3.05.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-283",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M436.41 276.79l-3.57 2.06-.27-1.58 3.58-2.06.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-284",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M421.94 330.97l7.31-4.22.26 1.56-7.31 4.23-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-285",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M415.26 334.81l5.29-3.05.26 1.57-5.28 3.06-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-286",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M410.31 337.68l3.57-2.06.26 1.57-3.57 2.06-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-287",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M419.51 336.32l7.31-4.22.27 1.57-7.31 4.23-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-288",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M412.84 340.18l5.28-3.06.27 1.57-5.28 3.06-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-289",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M407.88 343.04l3.57-2.07.27 1.57-3.57 2.08-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-290",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M389.99 329.68l2.48-1.43.26 1.57-2.47 1.44-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-291",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.35 332.37l3.26-1.9.26 1.58-3.26 1.88-.26-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-292",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M379.17 309.81l-7.31 4.22-.26-1.57 7.31-4.22.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-293",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.84 305.96l-5.28 3.05-.27-1.57 5.29-3.06.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-294",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M390.8 303.09l-3.58 2.07-.27-1.57 3.59-2.06.26 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-295",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M374.94 316.2l-2.48 1.42-.26-1.56 2.47-1.43.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-296",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M379.58 313.51l-3.26 1.89-.26-1.58 3.26-1.88.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-297",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M386.23 309.68l-5.26 3.03-.27-1.56 5.26-3.04.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-298",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M393.35 339.59l2.47-1.44.26 1.58-2.46 1.42-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-299",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M388.7 342.26l3.27-1.88.27 1.57-3.27 1.89-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-300",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M382.07 346.1l5.26-3.03.26 1.57-5.26 3.04-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-301",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M397.11 333.75l5.26-3.04.26 1.57-5.25 3.04-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-302",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M388.52 338.43l7.08-4.09.27 1.57-7.08 4.1-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-303",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M384.91 340.52l2.22-1.28.27 1.57-2.22 1.27-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-304",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M381.45 342.52l2.22-1.29.27 1.58-2.22 1.27-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-305",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M381.94 322.21l6.99-4.03.27 1.56-7 4.04-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-306",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M378.33 324.3l2.22-1.29.26 1.58-2.22 1.28-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-307",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M382.42 318l2.46-1.44.26 1.58-2.46 1.42-.26-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-308",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M391.13 320.87l2.47-1.43.27 1.58-2.48 1.42-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-309",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M394.65 318.84l5.92-3.42.27 1.58-5.93 3.41-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-310",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M401.62 314.81l3.52-2.04.27 1.59-3.52 2.03-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-311",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M377.77 320.67l3.26-1.88.27 1.57-3.26 1.89-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-312",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M377.46 316.98l2.47-1.42.27 1.57-2.47 1.42-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-313",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M372.81 319.67l3.26-1.89.27 1.58-3.26 1.88-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-314",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M387.54 322.94l2.22-1.28.27 1.57-2.22 1.28-.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-315",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M384.09 324.93l2.22-1.28.27 1.58-2.22 1.28-.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-316",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M401.12 342.99l7.56-4.38.26 1.58-7.56 4.37-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-317",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M392.65 347.88l7.09-4.1.26 1.58-7.09 4.09-.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-318",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M389.05 349.96l2.22-1.28.27 1.57-2.22 1.27-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-319",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M385.59 351.96l2.22-1.29.26 1.58-2.21 1.27-.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-320",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M383.71 353.04l-4.79 2.76.26 1.58 4.79-2.76-.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opensource-hero_svg__cls-4",
    d: "M118.5 453.22a10.88 10.88 0 01-5.43-1.45L8.71 391.55a3.39 3.39 0 010-5.87L74.07 348a1 1 0 01.94 0l109.32 63a3.4 3.4 0 010 5.88l-60.41 34.85a10.87 10.87 0 01-5.42 1.49zM74.55 348.59a.31.31 0 00-.13 0L9.08 386.32a2.65 2.65 0 000 4.6l104.35 60.22a10.23 10.23 0 005.07 1.35 10.16 10.16 0 005-1.35l60.5-34.86a2.67 2.67 0 000-4.61L74.66 348.61a.2.2 0 00-.11-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-321",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M74.41 323.93l14.53-86.2-1.2-.48 1.75-1a1.21 1.21 0 011.35.1l116.19 67a3.26 3.26 0 011.51 2.94l-14.66 86.91a1.1 1.1 0 01-.6.89l-1.73 1-.29-1.6h.1L76 326.88a3.29 3.29 0 01-1.59-2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-322",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M206.42 305.73l1.92-.84a2.64 2.64 0 01.24 1.44l-14.65 86.88a1.09 1.09 0 01-.61.89l-1.72 1-.29-1.6h.1l-5.85-3.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-323",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M74.09 327.93l116.19 67c.9.52 1.67.22 1.83-.71l14.65-86.89a3.28 3.28 0 00-1.51-2.95l-116.19-67c-.89-.52-1.66-.22-1.82.71L72.59 325a3.29 3.29 0 001.5 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-324",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M90.58 242.92l112 64.64-13.89 81.82L76.77 324.8l13.81-81.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-325",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M1.06 369.06l6.34 3.31L71 335.68a4.63 4.63 0 014.15.18l109.65 63.27c1-.59 5.82-2.88 5.82-2.88l-2.31 6a1.41 1.41 0 01-.66.72l-67 38.64a4.57 4.57 0 01-4.15-.17L4.35 376.72a2 2 0 01-.95-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-326",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-7",
    d: "M2 370.1l115 66.37a4.75 4.75 0 004.25.17l68.63-39.59c1.09-.64 1-1.74-.31-2.42l-115-66.3a4.67 4.67 0 00-4.24-.18l-68.59 39.6c-1.1.53-.95 1.63.26 2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-327",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-8",
    d: "M2 369.44l115 66.37a4.75 4.75 0 004.25.16l68.63-39.54a1.45 1.45 0 00.67-.75 1.21 1.21 0 01-.67 1.41l-68.63 39.6a4.78 4.78 0 01-4.25-.17L2 370.15c-.84-.48-1.21-1.21-1-1.71a2.07 2.07 0 001 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-328",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-9",
    d: "M172 393.33l-95.53-55.14a2.05 2.05 0 00-2.06 0l-34 19.66a.74.74 0 00-.37.64.73.73 0 00.37.64l95.52 55.12a2.1 2.1 0 002.06 0L172 394.59a.72.72 0 000-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-329",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-12",
    d: "M172 394.6l-.33.2-95.2-54.95a2.05 2.05 0 00-2.06 0l-33.69 19.49-.34-.2a.73.73 0 01-.37-.64.75.75 0 01.37-.64l34-19.67a2.05 2.05 0 012.06 0L172 393.33a.72.72 0 010 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-330",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M71.84 343.17l83.01 47.91 3.7-2.14-83.02-47.89-3.69 2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-331",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M62.79 348.39l77.87 44.93 3.69-2.12-77.87-44.93-3.69 2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-332",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M56.89 351.79l91.68 52.9 3.69-2.12-91.68-52.9-3.69 2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-333",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M51.01 355.2l91.67 52.9 3.7-2.13-91.68-52.9-3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-334",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M45.11 358.6l91.67 52.9 3.7-2.13-91.68-52.9-3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-335",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M159.87 393.97l3.69 2.12 3.7-2.12-3.7-2.13-3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-336",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M146.86 396.9l7.66 4.41 3.69-2.12-7.66-4.42-3.69 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-337",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-5",
    d: "M72.79 406.68L47 391.81a1.12 1.12 0 01-.74-1.05 1.14 1.14 0 01.74-1.06l17.63-10.15a4 4 0 013.62 0l25.8 14.86a1.1 1.1 0 010 2.09l-17.62 10.18a4 4 0 01-3.64 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-338",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-12",
    d: "M94.06 395.23L68.29 380.4a4 4 0 00-3.62 0L47 390.56a1.66 1.66 0 00-.63.63c-.26-.51-.06-1.09.63-1.49l17.63-10.15a4 4 0 013.62 0l25.8 14.86c.7.39.89 1 .63 1.48a1.54 1.54 0 00-.63-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-339",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M160.4 358.18l-9.06-5.23-.26 1.56 9.06 5.25.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-340",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M149.88 352.11l-4.93-2.85-.26 1.58 4.93 2.84.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-341",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M137.27 344.83l-3.57-2.07-.27 1.58 3.57 2.06.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-342",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M139.87 346.33l-1.21-.7-.27 1.58 1.22.7.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-343",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M143.48 348.41l-2.22-1.28-.26 1.57 2.22 1.28.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-344",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M153.24 346.16l-3.57-2.08-.27 1.58 3.57 2.07.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-345",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M161.62 350.99l-6.99-4.04-.27 1.57 7 4.05.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-346",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M151.59 325.51l-7-4.04-.27 1.58 7 4.04.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-347",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M155.19 327.59l-2.22-1.28-.26 1.57 2.22 1.28.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-348",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M150.42 332.7l-7-4.03-.27 1.56 7 4.05.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-349",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M154.02 334.79l-2.22-1.28-.26 1.57 2.22 1.28.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-350",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M156.75 294.46l13.18 7.62.27-1.57-13.19-7.62-.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-351",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M152.1 291.79l3.27 1.88.27-1.58-3.27-1.88-.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-352",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M128.94 290.25l13.19 7.62.25-1.57-13.18-7.61-.26 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-353",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M124.29 287.57l3.27 1.89.26-1.58-3.27-1.88-.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-354",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M165.76 303.61l3.57 2.07.27-1.58-3.57-2.07-.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-355",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M144.02 298.95l3.57 2.06.27-1.57-3.57-2.06-.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-356",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M157.38 298.77l6.99 4.04.27-1.57-7-4.04-.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-357",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M153.77 296.69l2.22 1.28.26-1.58-2.2-1.28-.28 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-358",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M145.33 291.82l6.99 4.04.27-1.58-7-4.04-.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-359",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M141.73 289.74l2.21 1.27.26-1.56-2.2-1.28-.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-360",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M144.64 295.36l3.57 2.06.26-1.57-3.57-2.06-.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-361",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M136.25 290.52l7 4.04.27-1.57-7-4.05-.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-362",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M132.65 288.44l2.22 1.27.26-1.57-2.22-1.27-.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-363",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M161.42 305.05l7.31 4.22.26-1.57-7.31-4.23-.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-364",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M154.75 301.19l5.28 3.05.27-1.57-5.29-3.05-.26 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-365",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M149.79 298.33l3.57 2.06.27-1.58-3.58-2.06-.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-366",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M115.14 282.3l7.31 4.23.27-1.58-7.31-4.22-.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-367",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M108.47 278.45l5.29 3.05.26-1.56-5.28-3.07-.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-368",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M103.52 275.58l3.58 2.08.25-1.58-3.57-2.06-.26 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-369",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M118 329.76l-7.31-4.22-.26 1.58 7.31 4.22.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-370",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M124.67 333.62l-5.28-3.05-.28 1.57 5.3 3.05.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-371",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M129.63 336.48l-3.58-2.06-.27 1.58 3.57 2.06.28-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-372",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M120.43 335.13l-7.31-4.22-.27 1.57 7.31 4.21.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-373",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M127.1 338.97l-5.29-3.05-.26 1.58 5.28 3.05.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-374",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M132.06 341.84l-3.57-2.06-.28 1.57 3.58 2.06.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-375",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M149.93 328.48l-2.46-1.43-.26 1.58 2.46 1.42.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-376",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M154.59 331.16l-3.27-1.88-.26 1.58 3.25 1.88.28-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-377",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M160.77 308.62l7.31 4.22.25-1.57-7.3-4.23-.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-378",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M154.09 304.76l5.29 3.06.26-1.58-5.28-3.05-.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-379",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M149.14 301.9l3.57 2.06.26-1.57-3.57-2.07-.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-380",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M165 315.01l2.46 1.42.27-1.57-2.46-1.43-.27 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-381",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M160.34 312.32l3.27 1.88.27-1.57-3.27-1.88-.27 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-382",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M153.71 308.48l5.26 3.04.26-1.58-5.26-3.04-.26 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-383",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M146.58 338.38l-2.47-1.42-.27 1.57 2.47 1.43.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-384",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M151.22 341.07l-3.25-1.88-.27 1.57 3.26 1.88.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-385",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M157.87 344.9l-5.26-3.03-.26 1.58 5.26 3.03.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-386",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M142.82 332.56l-5.26-3.04-.26 1.57 5.25 3.04.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-387",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M151.42 337.24l-7.08-4.09-.27 1.57 7.08 4.08.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-388",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M155.02 339.32l-2.21-1.29-.27 1.58 2.21 1.28.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-389",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M158.47 341.31l-2.22-1.28-.26 1.57 2.22 1.29.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-390",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M158 321.02l-7-4.05-.27 1.58 7.01 4.04.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-391",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M161.6 323.1l-2.22-1.28-.27 1.56 2.22 1.3.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-392",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M157.52 316.79l-2.47-1.42-.27 1.57 2.48 1.43.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-393",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M148.8 319.67l-2.46-1.42-.27 1.57 2.46 1.43.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-394",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-16",
    d: "M145.28 317.65l-5.93-3.43-.26 1.57 5.92 3.42.27-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-395",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M138.31 313.62l-3.53-2.04-.26 1.57 3.52 2.04.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-396",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M162.17 319.48l-3.27-1.88-.27 1.57 3.27 1.88.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-397",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M162.47 315.79l-2.46-1.43-.27 1.57 2.46 1.43.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-398",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M167.12 318.47l-3.27-1.89-.26 1.58 3.27 1.89.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-399",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M152.38 321.73l-2.22-1.28-.26 1.58 2.22 1.28.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-400",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M155.84 323.73l-2.21-1.27-.27 1.56 2.22 1.28.26-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-401",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M138.81 341.78l-7.56-4.36-.27 1.58 7.57 4.36.26-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-402",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M147.28 346.68l-7.08-4.09-.27 1.57 7.08 4.1.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-403",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M150.89 348.76l-2.22-1.28-.27 1.57 2.22 1.28.27-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-404",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M154.34 350.75l-2.22-1.28-.27 1.58 2.22 1.28.27-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opensource-hero_svg__Path-405",
    "data-name": "Path",
    className: "opensource-hero_svg__cls-10",
    d: "M156.23 351.85l4.78 2.76-.27 1.57-4.77-2.76.26-1.57z"
  }))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.47-.99h540v540H.47z"
  })));
}

export default __webpack_public_path__ + "static/opensource-hero.80cb018b.svg";
export { SvgOpensourceHero as ReactComponent };